const titlesByLanguage = {
  Tamil: ["அறத்துப்பால்", "பொருட்பால்", "இன்பத்துப்பால்"],
  English: ["Virtue", "Wealth", "Nature of Love"],
  telugu: ["ధర్మం", "సంపద", "ప్రేమ స్వభావం"],
  hindi: ["धर्म", "धन", "प्रेम"],
  kannad: ["ಧರ್ಮ", "సంపద", "ಪ್ರೇಮ"],
  french: ["Perfection", "Richesse", "Nature de l'Amour"],
  arabic: ["فضيلة", "الثروة", "طبيعة الحب"],
  chinese: ["美德", "财富", "爱的本质"],
  german: ["Tugend", "Wealth", "Natur des Verliebens"],
  korean: ["미덕", "재물", "사랑의 본성"],
  malay: ["Kesempurnaan", "Kekayaan", "Sifat Cinta"],
  malayalam: ["മന്നാല്‍", "പരിപാലനം", "അന്തരാളികം പ്രിയം"],
  polish: ["Dobroć", "Bogactwo", "Natura miłości"],
  russian: ["Добродетель", "Богатство", "Суть любви"],
  singalam: ["දානය", "අරමුණ", "සතුට"],
  swedish: ["Dygd", "Välst", "Kärlekens natur"],
};

export const getLanguageSpecificColumns = (language) => {
  switch (language) {
    case "Tamil":
      return {
        headingColumn: "iyal",
        chapterColumn: "tchapter",
        firstLineColumn: "firstline",
        secondLineColumn: "secondline",
        explanation: "kalaignar",
        explanationColumns: [
          "kalaignar",
          "salomon",
          "munisamy",
          "namakkal",
          "tamilkuzavi",
          "puliyur",
          "varadarajanar",
          "parimelazhagar",
          "manakudavar",
          "devaneya",
          "explanation",
        ],
      };
    case "telugu":
    case "hindi":
      return {
        headingColumn: "heading",
        chapterColumn: "chapter",
        firstLineColumn: language + "1",
        secondLineColumn: language + "2",
        explanation: "explanation",
      };
    case "English":
      return {
        headingColumn: "heading",
        chapterColumn: "chapter",
        firstLineColumn: "efirstline",
        secondLineColumn: "esecondline",
        explanation: "explanation",
      };
    default:
      return {
        headingColumn: "heading",
        chapterColumn: "chapter",
        firstLineColumn: language,
        secondLineColumn: "",
        explanation: "explanation",
      };
  }
};

export const getTitlesByLanguage = (language) => {
  return titlesByLanguage[language] || titlesByLanguage.Tamil;
};

export function getHeadingTranslation(heading, targetLanguage) {
  const translations = {
    English: {
      Miscelleanous: "Misc",
    },
    Tamil: {
      Kural: "குறள்",
      Explanation: "விளக்கம்",
      manakudavar: "மணக்குடவர் விளக்கம்",
      parimelazhagar: "பரிமேலழகர் விளக்கம்",
      varadarajanar: "மு. வரதராசனர் விளக்கம்",
      kalaignar: "கலைஞர் விளக்கம்",
      salomon: "சாலமன் பாப்பையா விளக்கம்",
      munisamy: "வ. முனிசாமி விளக்கம்",
      puliyur: "புலியூர் கேசிகன் விளக்கம்",
      devaneya: "தேவநேயப் பாவாணர் விளக்கம்",
      namakkal: "நாமக்கல் கவிஞர் விளக்கம்",
      tamilkuzavi: "தமிழ்க்குழவி விளக்கம்",
      explanation: "English விளக்கம்",
      "புதல்வரைப் பெறுதல்": "மக்கட்பேறு",
      "Love and Relationships": "அன்பு, உறவுகள்",
      "Personal Growth": "தனிப்பட்ட வளர்ச்சி",
      "Leadership and Success": "தலைமை, வெற்றி",
      "Philosophy and Nature": "தத்துவம், இயற்கை",
      "Career and Finance": "தொழில், நிதி",
      "Health and Wellness": "சுகாதாரம், ஆரோக்கியம்",
      "Ethics and Morality": "நெறிமுறைகள், அறநெறி",
      "Religion and Spirituality": "மதம், ஆன்மீகம்",
      "Politics and Society": "அரசியல், சமூகம்",
      "Science and Technology": "அறிவியல், தொழில்நுட்பம்",
      "Art and Creativity": "கலை, கலாச்சாரம்",
      "How does Thirukural define true love and relationships?":
        "உண்மையான அன்பையும் உறவுகளையும் திருக்குறள் எவ்வாறு வரையறுக்கிறது?",
      "What are Thirukural's views on the role of women in society?":
        "சமூகத்தில் பெண்களின் பங்கு பற்றிய திருக்குறளின் கருத்துக்கள் என்ன?",
      "How does Thirukural address the theme of love and its relationship to human emotions?":
        "திருக்குறள் அன்பின் கருப்பொருளையும் மனித உணர்வுகளுடனான அதன் உறவையும் எவ்வாறு குறிப்பிடுகிறது?",
      "What advice does Thirukural offer for overcoming adversity?":
        "துன்பங்களை வெல்வதற்கு திருக்குறள் என்ன அறிவுரை வழங்குகிறது?",
      "What lessons does Thirukural offer on the importance of humility?":
        "தாழ்த்தலின் முக்கியத்துவத்தைப் பற்றி திருக்குறள் என்ன பாடங்களை வழங்குகிறது?",
      "How does Thirukural address the theme of knowledge and its pursuit?":
        "அறிவு மற்றும் அதன் நோக்கத்தை திருக்குறள் எவ்வாறு குறிப்பிடுகிறது?",
      "Can you provide Thirukural's insights on effective leadership?":
        "திறமையான தலைமைத்துவம் பற்றிய திருக்குறளின் நுண்ணறிவுகளை உங்களால் வழங்க முடியுமா?",
      "What lessons does Thirukural offer on handling success and failure?":
        "வெற்றி தோல்வியைக் கையாள்வதில் திருக்குறள் என்ன பாடங்களை வழங்குகிறது?",
      "What are Thirukural's views on the balance between action and contemplation?":
        "செயலுக்கும் சிந்தனைக்கும் இடையே உள்ள சமநிலை பற்றிய திருக்குறளின் கருத்துக்கள் என்ன?",
      "How does Thirukural address the theme of time and its management?":
        "காலம் மற்றும் அதன் மேலாண்மை பற்றிய கருப்பொருளை திருக்குறள் எவ்வாறு குறிப்பிடுகிறது?",
      "Can you explain Thirukural's perspective on the relationship between humans and nature?":
        "மனிதர்களுக்கும் இயற்கைக்கும் இடையிலான உறவைப் பற்றிய திருக்குறளின் கண்ணோட்டத்தை விளக்க முடியுமா?",
      "What advice does Thirukural offer for managing finances?":
        "நிதிகளை நிர்வகிப்பதற்கு திருக்குறள் என்ன ஆலோசனை வழங்குகிறது?",
      "What lessons does Thirukural offer on the importance of hard work?":
        "கடின உழைப்பின் முக்கியத்துவம் குறித்து திருக்குறள் என்ன பாடங்களை வழங்குகிறது?",
      "How does Thirukural address the theme of success and its pursuit?":
        "திருக்குறள் வெற்றியின் கருப்பொருளையும் அதன் நோக்கத்தையும் எவ்வாறு குறிப்பிடுகிறது?",
      "How does Thirukural address the theme of health and its importance?":
        "ஆரோக்கியம் மற்றும் அதன் முக்கியத்துவத்தை திருக்குறள் எவ்வாறு எடுத்துரைக்கிறது?",
      "What lessons does Thirukural offer on the balance between work and rest?":
        "வேலைக்கும் ஓய்வுக்கும் இடையே உள்ள சமநிலை குறித்து திருக்குறள் என்ன பாடங்களை வழங்குகிறது?",
      "Can you provide Thirukural's insights on the concept of duty and its relationship to morality?":
        "கடமையின் கருத்து மற்றும் ஒழுக்கத்துடன் அதன் தொடர்பு பற்றிய திருக்குறளின் நுண்ணறிவுகளை உங்களால் வழங்க முடியுமா?",
      "What lessons does Thirukural offer on the importance of integrity and honesty?":
        "ஒருமைப்பாடு மற்றும் நேர்மையின் முக்கியத்துவம் குறித்து திருக்குறள் என்ன பாடங்களை வழங்குகிறது?",
      "How does Thirukural address the theme of faith and its relationship to spirituality?":
        "திருக்குறள் நம்பிக்கையின் கருப்பொருளையும் ஆன்மிகத்துடனான அதன் உறவையும் எவ்வாறு குறிப்பிடுகிறது?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to faith?":
        "தாழ்மையின் முக்கியத்துவம் மற்றும் நம்பிக்கையுடன் அதன் உறவு பற்றி திருக்குறள் என்ன பாடங்களை வழங்குகிறது?",
      "Can you provide Thirukural's insights on the concept of justice and its relationship to society?":
        "நீதி மற்றும் சமூகத்துடனான அதன் உறவு பற்றிய திருக்குறளின் நுண்ணறிவுகளை உங்களால் வழங்க முடியுமா?",
      "What lessons does Thirukural offer on the importance of compassion and its relationship to justice?":
        "இரக்கத்தின் முக்கியத்துவம் மற்றும் நீதிக்கான அதன் உறவு குறித்து திருக்குறள் என்ன பாடங்களை வழங்குகிறது?",
      "How does Thirukural address the theme of knowledge and its relationship to science and technology?":
        "அறிவின் கருப்பொருளையும் அறிவியலுக்கும் தொழில்நுட்பத்திற்கும் அதன் தொடர்பை திருக்குறள் எவ்வாறு குறிப்பிடுகிறது?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to knowledge?":
        "பணிவின் முக்கியத்துவம் மற்றும் அறிவுக்கும் அதன் தொடர்பு பற்றியும் திருக்குறள் என்ன பாடங்களை வழங்குகிறது?",
      "Can you provide Thirukural's insights on the concept of beauty and its relationship to art and creativity?":
        "அழகு பற்றிய கருத்து மற்றும் கலை மற்றும் படைப்பாற்றலுடன் அதன் தொடர்பு பற்றிய திருக்குறளின் நுண்ணறிவுகளை உங்களால் வழங்க முடியுமா?",
      "What lessons does Thirukural offer on the importance of integrity and its relationship to art?":
        "ஒருமைப்பாட்டின் முக்கியத்துவம் மற்றும் கலையுடனான அதன் உறவு குறித்து திருக்குறள் என்ன பாடங்களை வழங்குகிறது?",
    },
    telugu: {
      Preface: "ముందుమాట",
      "Domestic Virtue": "గృహస్థ ధర్మం",
      "Ascetic Virtue": "సన్యాస ధర్మం",
      Royalty: "రాజరికం",
      Ministry: "మంత్రిత్వశాఖ",
      Politics: "రాజకీయాలు",
      Friendship: "స్నేహం",
      Miscelleanous: "వివిధ విషయాలు",
      "Pre-marital love": "వివాహపూర్వ ప్రేమ",
      "Post-marital love": "వివాహానంతర ప్రేమ",
      "Love and Relationships": "అన్పు, సంబంధాలు",
      "Personal Growth": "దానిపట్టిన అభివృద్ధి",
      "Leadership and Success": "తలైమై, విజయం",
      "Philosophy and Nature": "తత్వం, ప్రకృతి",
      "Career and Finance": "తొళిల్, నిధి",
      "Health and Wellness": "సుకాధారం, ఆరోగ్యం",
      "Ethics and Morality": "నైరూప్యాలు, ఆచారణ",
      "Religion and Spirituality": "మతం, ఆధ్యాత్మికం",
      "Politics and Society": "అరషియల్, సంఘం",
      "Science and Technology": "అజ్ఞానం, సాంకేతికత",
      "Art and Creativity": "కలై, సంస్కృతి",
      "How does Thirukural define true love and relationships?":
        "తిరుక్కురల్ నిజమైన ప్రేమ మరియు సంబంధాలను ఎలా నిర్వచిస్తుంది?",
      "What are Thirukural's views on the role of women in society?":
        "సమాజంలో స్త్రీల పాత్రపై తిరుక్కురల్ అభిప్రాయాలు ఏమిటి?",
      "How does Thirukural address the theme of love and its relationship to human emotions?":
        "తిరుక్కురల్ ప్రేమ యొక్క ఇతివృత్తాన్ని మరియు మానవ భావోద్వేగాలతో దాని సంబంధాన్ని ఎలా సంబోధిస్తుంది?",
      "What advice does Thirukural offer for overcoming adversity?":
        "తిరుక్కురల్ ప్రతికూలతను అధిగమించడానికి ఏమి సలహా ఇస్తుంది?",
      "What lessons does Thirukural offer on the importance of humility?":
        "తిరుక్కురల్ వినయం యొక్క ప్రాముఖ్యత గురించి ఏ పాఠాలు బోధిస్తుంది?",
      "How does Thirukural address the theme of knowledge and its pursuit?":
        "తిరుక్కురల్ జ్ఞానం మరియు దాని ప్రయోజనాన్ని ఎలా సూచిస్తుంది?",
      "Can you provide Thirukural's insights on effective leadership?":
        "సమర్థవంతమైన నాయకత్వం గురించి మీరు అంతర్దృష్టిగల అంతర్దృష్టులను అందించగలరా?",
      "What lessons does Thirukural offer on handling success and failure?":
        "విజయం మరియు వైఫల్యాలను ఎదుర్కోవడంలో తిరుక్కురల్ ఏ పాఠాలను అందిస్తుంది?",
      "What are Thirukural's views on the balance between action and contemplation?":
        "చర్య మరియు ఆలోచన మధ్య సమతుల్యతపై తిరుక్కురల్ అభిప్రాయాలు ఏమిటి?",
      "How does Thirukural address the theme of time and its management?":
        "తిరుక్కురల్ సమయం మరియు దాని నిర్వహణ యొక్క ఇతివృత్తాన్ని ఎలా ప్రస్తావిస్తుంది?",
      "Can you explain Thirukural's perspective on the relationship between humans and nature?":
        "మానవులకు మరియు ప్రకృతికి మధ్య ఉన్న సంబంధంపై తిరుక్కురల్ యొక్క దృక్పథాన్ని మీరు వివరించగలరా?",
      "What advice does Thirukural offer for managing finances?":
        "ఆర్థిక నిర్వహణ కోసం తిరుక్కురల్ ఏ సలహాను అందిస్తుంది?",
      "What lessons does Thirukural offer on the importance of hard work?":
        "కఠిన శ్రమ యొక్క ప్రాముఖ్యత గురించి తిరుక్కురల్ ఏ పాఠాలు బోధిస్తుంది?",
      "How does Thirukural address the theme of success and its pursuit?":
        "తిరుక్కురల్ విజయం యొక్క ఇతివృత్తాన్ని మరియు దాని ప్రయోజనాన్ని ఎలా సూచిస్తుంది?",
      "How does Thirukural address the theme of health and its importance?":
        "తిరుక్కురల్ ఆరోగ్యం మరియు దాని ప్రాముఖ్యతను ఎలా తెలియజేస్తుంది?",
      "What lessons does Thirukural offer on the balance between work and rest?":
        "పని మరియు విశ్రాంతి మధ్య సమతుల్యత గురించి తిరుక్కురల్ ఏ పాఠాలు బోధిస్తుంది?",
      "Can you provide Thirukural's insights on the concept of duty and its relationship to morality?":
        "కర్తవ్యం యొక్క భావన మరియు నైతికతతో దాని సంబంధం గురించి మీరు అంతర్దృష్టిగల అంతర్దృష్టులను అందించగలరా?",
      "What lessons does Thirukural offer on the importance of integrity and honesty?":
        "నిజాయితీ మరియు చిత్తశుద్ధి యొక్క ప్రాముఖ్యత గురించి తిరుక్కురల్ ఏ పాఠాలు బోధిస్తుంది?",
      "How does Thirukural address the theme of faith and its relationship to spirituality?":
        "తిరుక్కురల్ విశ్వాసం యొక్క ఇతివృత్తాన్ని మరియు ఆధ్యాత్మికతకు దాని సంబంధాన్ని ఎలా ప్రస్తావిస్తుంది?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to faith?":
        "నమ్రత యొక్క ప్రాముఖ్యత మరియు విశ్వాసంతో దాని సంబంధం గురించి తిరుక్కురల్ ఏ పాఠాలు బోధిస్తుంది?",
      "Can you provide Thirukural's insights on the concept of justice and its relationship to society?":
        "న్యాయం మరియు సమాజంతో దాని సంబంధం గురించి మీరు అంతర్దృష్టితో కూడిన అంతర్దృష్టులను అందించగలరా?",
      "What lessons does Thirukural offer on the importance of compassion and its relationship to justice?":
        "తిరుక్కురల్ కరుణ యొక్క ప్రాముఖ్యత మరియు న్యాయంతో దాని సంబంధం గురించి ఏ పాఠాలను అందిస్తుంది?",
      "How does Thirukural address the theme of knowledge and its relationship to science and technology?":
        "తిరుక్కురల్ జ్ఞానం యొక్క థీమ్ మరియు సైన్స్ అండ్ టెక్నాలజీకి దాని సంబంధాన్ని ఎలా సంబోధిస్తుంది?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to knowledge?":
        "తిరుక్కురల్ వినయం యొక్క ప్రాముఖ్యత మరియు జ్ఞానంతో దాని సంబంధం గురించి ఏ పాఠాలు బోధిస్తుంది?",
      "Can you provide Thirukural's insights on the concept of beauty and its relationship to art and creativity?":
        "అందం యొక్క భావన మరియు కళ మరియు సృజనాత్మకతతో దాని సంబంధం గురించి మీరు తిరుక్కురల్ యొక్క అంతర్దృష్టులను అందించగలరా?",
      "What lessons does Thirukural offer on the importance of integrity and its relationship to art?":
        "సమగ్రత యొక్క ప్రాముఖ్యత మరియు కళతో దాని సంబంధం గురించి తిరుక్కురల్ ఏ పాఠాలను అందిస్తుంది?",
    },
    hindi: {
      Preface: "प्रस्तावना",
      "Domestic Virtue": "गृहस्थ धर्म",
      "Ascetic Virtue": "संन्यास धर्म",
      Royalty: "राजत्व",
      Ministry: "मंत्रालय",
      Politics: "राजनीति",
      Friendship: "मित्रता",
      Miscelleanous: "विविध",
      "Pre-marital love": "विवाह पूर्व प्रेम",
      "Post-marital love": "विवाह के बाद का प्रेम",
      "Love and Relationships": "प्यार, रिश्ते",
      "Personal Growth": "व्यक्तिगत विकास",
      "Leadership and Success": "नेतृत्व, सफलता",
      "Philosophy and Nature": "दर्शन, प्रकृति",
      "Career and Finance": "उद्योग, वित्त",
      "Health and Wellness": "स्वास्थ्य, स्वास्थ्य",
      "Ethics and Morality": "नैतिकता, नैतिकता",
      "Religion and Spirituality": "धर्म, अध्यात्म",
      "Politics and Society": "राजनीति, समाज",
      "Science and Technology": "विज्ञान प्रौद्योगिकी",
      "Art and Creativity": "कला, संस्कृति",
      "How does Thirukural define true love and relationships?":
        "थिरुक्कुरल सच्चे प्यार और रिश्तों को कैसे परिभाषित करता है?",
      "What are Thirukural's views on the role of women in society?":
        "समाज में महिलाओं की भूमिका पर तिरुक्कुरल के क्या विचार थे?",
      "How does Thirukural address the theme of love and its relationship to human emotions?":
        "थिरुक्कुरल प्रेम के विषय और मानवीय भावनाओं के साथ उसके संबंध को कैसे संबोधित करता है?",
      "What advice does Thirukural offer for overcoming adversity?":
        "विपरीत परिस्थितियों से उबरने के लिए तिरुक्कुरल क्या सलाह देते हैं?",
      "What lessons does Thirukural offer on the importance of humility?":
        "तिरुक्कुरल विनम्रता के महत्व के बारे में क्या सबक सिखाता है?",
      "How does Thirukural address the theme of knowledge and its pursuit?":
        "तिरुक्कुरल ज्ञान और उसके उद्देश्य को कैसे संदर्भित करता है?",
      "Can you provide Thirukural's insights on effective leadership?":
        "क्या आप प्रभावी नेतृत्व में व्यावहारिक अंतर्दृष्टि प्रदान कर सकते हैं?",
      "What lessons does Thirukural offer on handling success and failure?":
        "थिरुक्कुरल सफलता और असफलता से निपटने में क्या सबक देता है?",
      "What are Thirukural's views on the balance between action and contemplation?":
        "क्रिया और विचार के बीच संतुलन पर तिरुक्कुरल के क्या विचार थे?",
      "How does Thirukural address the theme of time and its management?":
        "तिरुक्कुरल समय और उसके प्रबंधन के विषय को कैसे संबोधित करता है?",
      "Can you explain Thirukural's perspective on the relationship between humans and nature?":
        "क्या आप मनुष्य और प्रकृति के बीच संबंधों पर तिरुक्कुरल के दृष्टिकोण को समझा सकते हैं?",
      "What advice does Thirukural offer for managing finances?":
        "तिरुक्कुरल वित्त प्रबंधन के लिए क्या सलाह देता है?",
      "What lessons does Thirukural offer on the importance of hard work?":
        "थिरुक्कुरल कड़ी मेहनत के महत्व के बारे में क्या सबक सिखाता है?",
      "How does Thirukural address the theme of success and its pursuit?":
        "थिरुक्कुरल विजय के विषय और उसके उद्देश्य को किस प्रकार संदर्भित करता है?",
      "How does Thirukural address the theme of health and its importance?":
        "तिरुक्कुरल स्वास्थ्य और इसके महत्व को कैसे संबोधित करता है?",
      "What lessons does Thirukural offer on the balance between work and rest?":
        "थिरुक्कुरल काम और अवकाश के बीच संतुलन के बारे में क्या सबक सिखाता है?",
      "Can you provide Thirukural's insights on the concept of duty and its relationship to morality?":
        "क्या आप कर्तव्य की अवधारणा और नैतिकता से इसके संबंध के बारे में व्यावहारिक अंतर्दृष्टि प्रदान कर सकते हैं?",
      "What lessons does Thirukural offer on the importance of integrity and honesty?":
        "तिरुक्कुरल निष्ठा और ईमानदारी के महत्व के बारे में क्या सबक सिखाता है?",
      "How does Thirukural address the theme of faith and its relationship to spirituality?":
        "थिरुक्कुरल आस्था के विषय और आध्यात्मिकता के साथ इसके संबंध को कैसे संबोधित करता है?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to faith?":
        "तिरुक्कुरल विनम्रता के महत्व और विश्वास के साथ इसके संबंध के बारे में क्या सबक सिखाता है?",
      "Can you provide Thirukural's insights on the concept of justice and its relationship to society?":
        "क्या आप न्याय और समाज के साथ उसके संबंधों के बारे में व्यावहारिक अंतर्दृष्टि प्रदान कर सकते हैं?",
      "What lessons does Thirukural offer on the importance of compassion and its relationship to justice?":
        "थिरुक्कुरल करुणा के महत्व और न्याय के साथ इसके संबंध के बारे में क्या सबक देता है?",
      "How does Thirukural address the theme of knowledge and its relationship to science and technology?":
        "थिरुक्कुरल ज्ञान के विषय और विज्ञान और प्रौद्योगिकी से इसके संबंध को कैसे संबोधित करता है?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to knowledge?":
        "तिरुक्कुरल काम के महत्व और ज्ञान से इसके संबंध के बारे में क्या सबक सिखाता है?",
      "Can you provide Thirukural's insights on the concept of beauty and its relationship to art and creativity?":
        "क्या आप सुंदरता की अवधारणा और कला और रचनात्मकता से इसके संबंध में तिरुक्कुरल की अंतर्दृष्टि प्रदान कर सकते हैं?",
      "What lessons does Thirukural offer on the importance of integrity and its relationship to art?":
        "थिरुक्कुरल अखंडता के महत्व और कला के साथ इसके संबंध के बारे में क्या सबक देता है?",
    },
    kannad: {
      Preface: "ಮುನ್ನುಡಿ",
      "Domestic Virtue": "ಗೃಹಸ್ಥ ಧರ್ಮ",
      "Ascetic Virtue": "ಸನ್ಯಾಸ ಧರ್ಮ",
      Royalty: "ರಾಜತ್ವ",
      Ministry: "ಸಚಿವಾಲಯ",
      Politics: "ರಾಜಕೀಯ",
      Friendship: "ಸ್ನೇಹ",
      Miscelleanous: "ವಿವಿಧ",
      "Pre-marital love": "ವಿವಾಹಪೂರ್ವ ಪ್ರೀತಿ",
      "Post-marital love": "ವಿವಾಹಾನಂತರ ಪ್ರೀತಿ",
      "Love and Relationships": "ಪ್ರೀತಿ, ಸಂಬಂಧಗಳು",
      "Personal Growth": "ವೈಯಕ್ತಿಕ ಅಭಿವೃದ್ಧಿ",
      "Leadership and Success": "ನಾಯಕತ್ವ, ಯಶಸ್ಸು",
      "Philosophy and Nature": "ತತ್ವಶಾಸ್ತ್ರ, ಪ್ರಕೃತಿ",
      "Career and Finance": "ಕೈಗಾರಿಕೆ, ಹಣಕಾಸು",
      "Health and Wellness": "ಆರೋಗ್ಯ, ಆರೋಗ್ಯ",
      "Ethics and Morality": "ನೈತಿಕತೆ, ನೈತಿಕತೆ",
      "Religion and Spirituality": "ಧರ್ಮ, ಆಧ್ಯಾತ್ಮಿಕತೆ",
      "Politics and Society": "ರಾಜಕೀಯ, ಸಮಾಜ",
      "Science and Technology": "ವಿಜ್ಞಾನ, ತಂತ್ರಜ್ಞಾನ",
      "Art and Creativity": "ಕಲೆ, ಸಂಸ್ಕೃತಿ",
      "How does Thirukural define true love and relationships?":
        "ತಿರುಕ್ಕುರಲ್ ನಿಜವಾದ ಪ್ರೀತಿ ಮತ್ತು ಸಂಬಂಧಗಳನ್ನು ಹೇಗೆ ವ್ಯಾಖ್ಯಾನಿಸುತ್ತದೆ?",
      "What are Thirukural's views on the role of women in society?":
        "ಸಮಾಜದಲ್ಲಿ ಮಹಿಳೆಯರ ಪಾತ್ರದ ಕುರಿತು ತಿರುಕ್ಕುರಲ್ ಅವರ ಅಭಿಪ್ರಾಯಗಳು ಯಾವುವು?",
      "How does Thirukural address the theme of love and its relationship to human emotions?":
        "ತಿರುಕ್ಕುರಲ್ ಪ್ರೀತಿಯ ವಿಷಯ ಮತ್ತು ಮಾನವ ಭಾವನೆಗಳೊಂದಿಗೆ ಅದರ ಸಂಬಂಧವನ್ನು ಹೇಗೆ ತಿಳಿಸುತ್ತದೆ?",
      "What advice does Thirukural offer for overcoming adversity?":
        "ತಿರುಕ್ಕುರಲ್ ಪ್ರತಿಕೂಲತೆಯನ್ನು ಜಯಿಸಲು ಯಾವ ಸಲಹೆಯನ್ನು ನೀಡುತ್ತದೆ?",
      "What lessons does Thirukural offer on the importance of humility?":
        "ತಿರುಕ್ಕುರಲ್ ನಮ್ರತೆಯ ಮಹತ್ವದ ಬಗ್ಗೆ ಯಾವ ಪಾಠಗಳನ್ನು ಕಲಿಸುತ್ತದೆ?",
      "How does Thirukural address the theme of knowledge and its pursuit?":
        "ತಿರುಕ್ಕುರಲ್ ಜ್ಞಾನ ಮತ್ತು ಅದರ ಉದ್ದೇಶವನ್ನು ಹೇಗೆ ಉಲ್ಲೇಖಿಸುತ್ತದೆ?",
      "Can you provide Thirukural's insights on effective leadership?":
        "ಪರಿಣಾಮಕಾರಿ ನಾಯಕತ್ವದ ಬಗ್ಗೆ ನೀವು ನಿರ್ಣಾಯಕ ಒಳನೋಟಗಳನ್ನು ನೀಡಬಹುದೇ?",
      "What lessons does Thirukural offer on handling success and failure?":
        "ಯಶಸ್ಸು ಮತ್ತು ವೈಫಲ್ಯವನ್ನು ಎದುರಿಸುವಲ್ಲಿ ತಿರುಕ್ಕುರಲ್ ಯಾವ ಪಾಠಗಳನ್ನು ನೀಡುತ್ತದೆ?",
      "What are Thirukural's views on the balance between action and contemplation?":
        "ಕ್ರಿಯೆ ಮತ್ತು ಚಿಂತನೆಯ ನಡುವಿನ ಸಮತೋಲನದ ಕುರಿತು ತಿರುಕ್ಕುರಲ್ ಅವರ ಅಭಿಪ್ರಾಯಗಳು ಯಾವುವು?",
      "How does Thirukural address the theme of time and its management?":
        "ತಿರುಕ್ಕುರಲ್ ಸಮಯ ಮತ್ತು ಅದರ ನಿರ್ವಹಣೆಯ ವಿಷಯವನ್ನು ಹೇಗೆ ತಿಳಿಸುತ್ತದೆ?",
      "Can you explain Thirukural's perspective on the relationship between humans and nature?":
        "ಮನುಷ್ಯರು ಮತ್ತು ಪ್ರಕೃತಿಯ ನಡುವಿನ ಸಂಬಂಧದ ಕುರಿತು ತಿರುಕ್ಕುರಲ್‌ನ ದೃಷ್ಟಿಕೋನವನ್ನು ನೀವು ವಿವರಿಸಬಹುದೇ?",
      "What advice does Thirukural offer for managing finances?":
        "ಹಣಕಾಸು ನಿರ್ವಹಣೆಗಾಗಿ ತಿರುಕ್ಕುರಲ್ ಯಾವ ಸಲಹೆಯನ್ನು ನೀಡುತ್ತದೆ?",
      "What lessons does Thirukural offer on the importance of hard work?":
        "ತಿರುಕ್ಕುರಲ್ ಕಠಿಣ ಪರಿಶ್ರಮದ ಮಹತ್ವದ ಬಗ್ಗೆ ಯಾವ ಪಾಠಗಳನ್ನು ಕಲಿಸುತ್ತದೆ?",
      "How does Thirukural address the theme of success and its pursuit?":
        "ತಿರುಕ್ಕುರಲ್ ವಿಜಯದ ವಿಷಯ ಮತ್ತು ಅದರ ಉದ್ದೇಶವನ್ನು ಹೇಗೆ ಉಲ್ಲೇಖಿಸುತ್ತದೆ?",
      "How does Thirukural address the theme of health and its importance?":
        "ತಿರುಕ್ಕುರಲ್ ಆರೋಗ್ಯ ಮತ್ತು ಅದರ ಪ್ರಾಮುಖ್ಯತೆಯನ್ನು ಹೇಗೆ ತಿಳಿಸುತ್ತದೆ?",
      "What lessons does Thirukural offer on the balance between work and rest?":
        "ಕೆಲಸ ಮತ್ತು ವಿರಾಮದ ನಡುವಿನ ಸಮತೋಲನದ ಬಗ್ಗೆ ತಿರುಕ್ಕುರಲ್ ಯಾವ ಪಾಠಗಳನ್ನು ಕಲಿಸುತ್ತದೆ?",
      "Can you provide Thirukural's insights on the concept of duty and its relationship to morality?":
        "ಕರ್ತವ್ಯದ ಪರಿಕಲ್ಪನೆ ಮತ್ತು ನೈತಿಕತೆಗೆ ಅದರ ಸಂಬಂಧದ ಬಗ್ಗೆ ನೀವು ಒಳನೋಟವುಳ್ಳ ಒಳನೋಟಗಳನ್ನು ನೀಡಬಹುದೇ?",
      "What lessons does Thirukural offer on the importance of integrity and honesty?":
        "ಸಮಗ್ರತೆ ಮತ್ತು ಪ್ರಾಮಾಣಿಕತೆಯ ಮಹತ್ವದ ಬಗ್ಗೆ ತಿರುಕ್ಕುರಲ್ ಯಾವ ಪಾಠಗಳನ್ನು ಕಲಿಸುತ್ತದೆ?",
      "How does Thirukural address the theme of faith and its relationship to spirituality?":
        "ತಿರುಕ್ಕುರಲ್ ನಂಬಿಕೆಯ ವಿಷಯ ಮತ್ತು ಆಧ್ಯಾತ್ಮಿಕತೆಗೆ ಅದರ ಸಂಬಂಧವನ್ನು ಹೇಗೆ ತಿಳಿಸುತ್ತದೆ?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to faith?":
        "ನಮ್ರತೆಯ ಪ್ರಾಮುಖ್ಯತೆ ಮತ್ತು ನಂಬಿಕೆಯೊಂದಿಗೆ ಅದರ ಸಂಬಂಧದ ಬಗ್ಗೆ ತಿರುಕ್ಕುರಲ್ ಯಾವ ಪಾಠಗಳನ್ನು ಕಲಿಸುತ್ತದೆ?",
      "Can you provide Thirukural's insights on the concept of justice and its relationship to society?":
        "ನೀವು ನ್ಯಾಯ ಮತ್ತು ಸಮಾಜದೊಂದಿಗಿನ ಅದರ ಸಂಬಂಧದ ಬಗ್ಗೆ ಒಳನೋಟವುಳ್ಳ ಒಳನೋಟಗಳನ್ನು ನೀಡಬಹುದೇ?",
      "What lessons does Thirukural offer on the importance of compassion and its relationship to justice?":
        "ಕರುಣೆಯ ಪ್ರಾಮುಖ್ಯತೆ ಮತ್ತು ನ್ಯಾಯಕ್ಕೆ ಅದರ ಸಂಬಂಧದ ಬಗ್ಗೆ ತಿರುಕ್ಕುರಲ್ ಯಾವ ಪಾಠಗಳನ್ನು ನೀಡುತ್ತದೆ?",
      "How does Thirukural address the theme of knowledge and its relationship to science and technology?":
        "ತಿರುಕ್ಕುರಲ್ ಜ್ಞಾನದ ವಿಷಯ ಮತ್ತು ವಿಜ್ಞಾನ ಮತ್ತು ತಂತ್ರಜ್ಞಾನಕ್ಕೆ ಅದರ ಸಂಬಂಧವನ್ನು ಹೇಗೆ ತಿಳಿಸುತ್ತದೆ?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to knowledge?":
        "ತಿರುಕ್ಕುರಲ್ ಕೆಲಸದ ಮಹತ್ವ ಮತ್ತು ಜ್ಞಾನದ ಸಂಬಂಧದ ಬಗ್ಗೆ ಯಾವ ಪಾಠಗಳನ್ನು ಕಲಿಸುತ್ತದೆ?",
      "Can you provide Thirukural's insights on the concept of beauty and its relationship to art and creativity?":
        "ಸೌಂದರ್ಯದ ಪರಿಕಲ್ಪನೆ ಮತ್ತು ಕಲೆ ಮತ್ತು ಸೃಜನಶೀಲತೆಗೆ ಅದರ ಸಂಬಂಧದ ಬಗ್ಗೆ ತಿರುಕ್ಕುರಲ್‌ನ ಒಳನೋಟಗಳನ್ನು ನೀವು ಒದಗಿಸಬಹುದೇ?",
      "What lessons does Thirukural offer on the importance of integrity and its relationship to art?":
        "ಸಮಗ್ರತೆಯ ಪ್ರಾಮುಖ್ಯತೆ ಮತ್ತು ಕಲೆಗೆ ಅದರ ಸಂಬಂಧದ ಬಗ್ಗೆ ತಿರುಕ್ಕುರಲ್ ಯಾವ ಪಾಠಗಳನ್ನು ನೀಡುತ್ತದೆ?",
    },
    french: {
      Preface: "Préface",
      "Domestic Virtue": "Vertu domestique",
      "Ascetic Virtue": "Vertu ascétique",
      Royalty: "Royauté",
      Ministry: "Ministère",
      Politics: "Politique",
      Friendship: "Amitié",
      Miscelleanous: "Divers",
      "Pre-marital love": "Amour prénuptial",
      "Post-marital love": "Amour post-marital",
      "Love and Relationships": "Amour, Relations",
      "Personal Growth": "Développement personnel",
      "Leadership and Success": "Leadership, Succès",
      "Philosophy and Nature": "Philosophie, Nature",
      "Career and Finance": "Industrie, Finances",
      "Health and Wellness": "Santé, Santé",
      "Ethics and Morality": "Ethique, Moralité",
      "Religion and Spirituality": "Religion, Spiritualité",
      "Politics and Society": "Politique, Société",
      "Science and Technology": "Sciences, Technologie",
      "Art and Creativity": "Arts, Cultures",
      "How does Thirukural define true love and relationships?":
        "Comment Thirukkural définit-il le véritable amour et les relations ?",
      "What are Thirukural's views on the role of women in society?":
        "Quels étaient les points de vue de Thirukkural sur le rôle des femmes dans la société ?",
      "How does Thirukural address the theme of love and its relationship to human emotions?":
        "Comment Thirukkural aborde-t-il le thème de l'amour et sa relation avec les émotions humaines ?",
      "What advice does Thirukural offer for overcoming adversity?":
        "Quels conseils Tirukkural donne-t-il pour surmonter l'adversité ?",
      "What lessons does Thirukural offer on the importance of humility?":
        "Quelles leçons Tirukkural enseigne-t-il sur l'importance de l'humilité ?",
      "How does Thirukural address the theme of knowledge and its pursuit?":
        "Comment Tirukkural fait-il référence à la connaissance et à son objectif ?",
      "Can you provide Thirukural's insights on effective leadership?":
        "Pouvez-vous fournir des informations essentielles sur un leadership efficace ?",
      "What lessons does Thirukural offer on handling success and failure?":
        "Quelles leçons Tirukkural offre-t-il pour faire face au succès et à l'échec ?",
      "What are Thirukural's views on the balance between action and contemplation?":
        "Quels sont les points de vue de Thirukkural sur l'équilibre entre l'action et la pensée ?",
      "How does Thirukural address the theme of time and its management?":
        "Comment Tirukkural aborde-t-il le thème du temps et de sa gestion ?",
      "Can you explain Thirukural's perspective on the relationship between humans and nature?":
        "Pouvez-vous expliquer le point de vue de Thirukkural sur la relation entre les humains et la nature ?",
      "What advice does Thirukural offer for managing finances?":
        "Quels conseils Thirukkural propose-t-il pour gérer ses finances ?",
      "What lessons does Thirukural offer on the importance of hard work?":
        "Quelles leçons Thirukkural enseigne-t-il sur l'importance du travail acharné ?",
      "How does Thirukural address the theme of success and its pursuit?":
        "Comment Thirukkural fait-il référence au thème de la victoire et à son objectif ?",
      "How does Thirukural address the theme of health and its importance?":
        "Comment Thirukkural aborde-t-il la santé et son importance ?",
      "What lessons does Thirukural offer on the balance between work and rest?":
        "Quelles leçons Thirukkural enseigne-t-il sur l'équilibre entre travail et loisirs ?",
      "Can you provide Thirukural's insights on the concept of duty and its relationship to morality?":
        "Pouvez-vous donner un aperçu perspicace du concept de devoir et de sa relation avec la moralité ?",
      "What lessons does Thirukural offer on the importance of integrity and honesty?":
        "Quelles leçons Thirukkural enseigne-t-il sur l'importance de l'intégrité et de l'honnêteté ?",
      "How does Thirukural address the theme of faith and its relationship to spirituality?":
        "Comment Thirukkural aborde-t-il le thème de la foi et sa relation avec la spiritualité ?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to faith?":
        "Quelles leçons Tirukkural enseigne-t-il sur l'importance de l'humilité et sa relation avec la foi ?",
      "Can you provide Thirukural's insights on the concept of justice and its relationship to society?":
        "Pouvez-vous fournir un aperçu perspicace de la justice et de ses relations avec la société ?",
      "What lessons does Thirukural offer on the importance of compassion and its relationship to justice?":
        "Quelles leçons Thirukkural offre-t-il sur l'importance de la compassion et sa relation avec la justice ?",
      "How does Thirukural address the theme of knowledge and its relationship to science and technology?":
        "Comment Thirukkural aborde-t-il le thème de la connaissance et sa relation avec la science et la technologie ?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to knowledge?":
        "Quelles leçons Thirukkural enseigne-t-il sur l'importance du travail et sa relation avec la connaissance ?",
      "Can you provide Thirukural's insights on the concept of beauty and its relationship to art and creativity?":
        "Pouvez-vous nous donner le point de vue de Thirukkural sur le concept de beauté et sa relation avec l'art et la créativité ?",
      "What lessons does Thirukural offer on the importance of integrity and its relationship to art?":
        "Quelles leçons Thirukkural offre-t-il sur l'importance de l'intégrité et sa relation avec l'art ?",
    },
    arabic: {
      Preface: "مقدمة",
      "Domestic Virtue": "الفضيلة المنزلية",
      "Ascetic Virtue": "الفضيلة الزهدية",
      Royalty: "الملكية",
      Ministry: "الوزارة",
      Politics: "السياسة",
      Friendship: "الصداقة",
      Miscelleanous: "متنوع",
      "Pre-marital love": "الحب قبل الزواج",
      "Post-marital love": "الحب بعد الزواج",
      "Love and Relationships": "الحب والعلاقات",
      "Personal Growth": "تنمية الشخصية",
      "Leadership and Success": "القيادة، النجاح",
      "Philosophy and Nature": "الفلسفة، الطبيعة",
      "Career and Finance": "الصناعة والمالية",
      "Health and Wellness": "الصحة، الصحة",
      "Ethics and Morality": "الأخلاق والأخلاق",
      "Religion and Spirituality": "الدين والروحانية",
      "Politics and Society": "السياسة والمجتمع",
      "Science and Technology": "العلوم والتكنولوجيا",
      "Art and Creativity": "الفن والثقافة",
      "How does Thirukural define true love and relationships?":
        "كيف يحدد Thirukkural الحب الحقيقي والعلاقات؟",
      "What are Thirukural's views on the role of women in society?":
        "ما هي آراء ثيروكورال حول دور المرأة في المجتمع؟",
      "How does Thirukural address the theme of love and its relationship to human emotions?":
        "كيف يتناول ثيروكورال موضوع الحب وعلاقته بالمشاعر الإنسانية؟",
      "What advice does Thirukural offer for overcoming adversity?":
        "ما النصيحة التي يقدمها تيروكورال للتغلب على الشدائد؟",
      "What lessons does Thirukural offer on the importance of humility?":
        "ما هي الدروس التي يعلمها تيروكورال حول أهمية التواضع؟",
      "How does Thirukural address the theme of knowledge and its pursuit?":
        "كيف يشير تيروكورال إلى المعرفة والغرض منها؟",
      "Can you provide Thirukural's insights on effective leadership?":
        "هل يمكنك تقديم رؤى نقدية حول القيادة الفعالة؟",
      "What lessons does Thirukural offer on handling success and failure?":
        "ما هي الدروس التي يقدمها تيروكورال في التعامل مع النجاح والفشل؟",
      "What are Thirukural's views on the balance between action and contemplation?":
        "ما هي آراء ثيروكورال حول التوازن بين العمل والفكر؟",
      "How does Thirukural address the theme of time and its management?":
        "كيف يعالج تيروكورال موضوع الوقت وإدارته؟",
      "Can you explain Thirukural's perspective on the relationship between humans and nature?":
        "هل يمكنك شرح وجهة نظر ثيروكورال حول العلاقة بين البشر والطبيعة؟",
      "What advice does Thirukural offer for managing finances?":
        "ما هي النصيحة التي يقدمها Thirukkural لإدارة الشؤون المالية؟",
      "What lessons does Thirukural offer on the importance of hard work?":
        "ما هي الدروس التي يعلمها ثيروكورال حول أهمية العمل الجاد؟",
      "How does Thirukural address the theme of success and its pursuit?":
        "كيف يشير ثيروكورال إلى موضوع النصر والغرض منه؟",
      "How does Thirukural address the theme of health and its importance?":
        "كيف يعالج Thirukkural الصحة وأهميتها؟",
      "What lessons does Thirukural offer on the balance between work and rest?":
        "ما هي الدروس التي يعلمها ثيروكورال حول التوازن بين العمل والترفيه؟",
      "Can you provide Thirukural's insights on the concept of duty and its relationship to morality?":
        "هل يمكنك تقديم رؤى ثاقبة حول مفهوم الواجب وعلاقته بالأخلاق؟",
      "What lessons does Thirukural offer on the importance of integrity and honesty?":
        "ما هي الدروس التي يعلمها ثيروكورال حول أهمية النزاهة والصدق؟",
      "How does Thirukural address the theme of faith and its relationship to spirituality?":
        "كيف يتناول ثيروكوكورال موضوع الإيمان وعلاقته بالروحانية؟",
      "What lessons does Thirukural offer on the importance of humility and its relationship to faith?":
        "ما هي الدروس التي يعلمها تيروكورال عن أهمية التواضع وعلاقته بالإيمان؟",
      "Can you provide Thirukural's insights on the concept of justice and its relationship to society?":
        "هل يمكنك تقديم رؤى ثاقبة حول العدالة وعلاقتها بالمجتمع؟",
      "What lessons does Thirukural offer on the importance of compassion and its relationship to justice?":
        "ما هي الدروس التي يقدمها ثيروكورال حول أهمية التعاطف وعلاقته بالعدالة؟",
      "How does Thirukural address the theme of knowledge and its relationship to science and technology?":
        "كيف يتناول ثيروكوال موضوع المعرفة وعلاقتها بالعلم والتكنولوجيا؟",
      "What lessons does Thirukural offer on the importance of humility and its relationship to knowledge?":
        "ما هي الدروس التي يعلمها ثيروكوال حول أهمية العمل وعلاقته بالمعرفة؟",
      "Can you provide Thirukural's insights on the concept of beauty and its relationship to art and creativity?":
        "هل يمكنك تقديم رؤى ثيروكورال حول مفهوم الجمال وعلاقته بالفن والإبداع؟",
      "What lessons does Thirukural offer on the importance of integrity and its relationship to art?":
        "ما هي الدروس التي يقدمها Thirukkural حول أهمية النزاهة وعلاقتها بالفن؟",
    },
    chinese: {
      Preface: "序言",
      "Domestic Virtue": "家庭美德",
      "Ascetic Virtue": "苦行美德",
      Royalty: "王权",
      Ministry: "部门",
      Politics: "政治",
      Friendship: "友谊",
      Miscelleanous: "杂项",
      "Pre-marital love": "婚前恋爱",
      "Post-marital love": "婚后恋爱",
      "Love and Relationships": "爱，关系",
      "Personal Growth": "个人发展",
      "Leadership and Success": "领导力，成功",
      "Philosophy and Nature": "哲学，自然",
      "Career and Finance": "《产业、金融》",
      "Health and Wellness": "健康，健康",
      "Ethics and Morality": "伦理、道德",
      "Religion and Spirituality": "宗教、灵性",
      "Politics and Society": "《政治、社会》",
      "Science and Technology": "科学、技术",
      "Art and Creativity": "艺术、文化",
      "How does Thirukural define true love and relationships?":
        "蒂鲁库拉尔如何定义真爱和关系？",
      "What are Thirukural's views on the role of women in society?":
        "蒂鲁库拉尔对女性在社会中的角色有何看法？",
      "How does Thirukural address the theme of love and its relationship to human emotions?":
        "蒂鲁库拉尔如何阐述爱的主题及其与人类情感的关系？",
      "What advice does Thirukural offer for overcoming adversity?":
        "蒂鲁库拉尔提出什么建议来克服逆境？",
      "What lessons does Thirukural offer on the importance of humility?":
        "关于谦逊的重要性，蒂鲁库拉尔教授了哪些教训？",
      "How does Thirukural address the theme of knowledge and its pursuit?":
        "蒂鲁库拉尔如何指代知识及其目的？",
      "Can you provide Thirukural's insights on effective leadership?":
        "您能提供有关有效领导力的深刻见解吗？",
      "What lessons does Thirukural offer on handling success and failure?":
        "蒂鲁库拉尔在处理成功和失败方面提供了哪些教训？",
      "What are Thirukural's views on the balance between action and contemplation?":
        "蒂鲁库拉尔对行动与思想之间的平衡有何看法？",
      "How does Thirukural address the theme of time and its management?":
        "蒂鲁库拉尔如何阐述时间及其管理的主题？",
      "Can you explain Thirukural's perspective on the relationship between humans and nature?":
        "您能解释一下蒂鲁古拉尔对人与自然关系的看法吗？",
      "What advice does Thirukural offer for managing finances?":
        "Thirukkural 为财务管理提供了哪些建议？",
      "What lessons does Thirukural offer on the importance of hard work?":
        "关于努力工作的重要性，蒂鲁古拉尔教授了哪些教训？",
      "How does Thirukural address the theme of success and its pursuit?":
        "蒂鲁库拉尔如何提及胜利的主题及其目的？",
      "How does Thirukural address the theme of health and its importance?":
        "蒂鲁库拉尔如何解决健康问题及其重要性？",
      "What lessons does Thirukural offer on the balance between work and rest?":
        "Thirukkural 教授了哪些关于工作与休闲之间的平衡的课程？",
      "Can you provide Thirukural's insights on the concept of duty and its relationship to morality?":
        "你能对责任的概念及其与道德的关系提供深刻的见解吗？",
      "What lessons does Thirukural offer on the importance of integrity and honesty?":
        "关于正直和诚实的重要性，蒂鲁古拉尔教授了哪些教训？",
      "How does Thirukural address the theme of faith and its relationship to spirituality?":
        "蒂鲁库拉尔如何阐述信仰的主题及其与灵性的关系？",
      "What lessons does Thirukural offer on the importance of humility and its relationship to faith?":
        "关于谦卑的重要性及其与信仰的关系，蒂鲁库拉尔教导了哪些教训？",
      "Can you provide Thirukural's insights on the concept of justice and its relationship to society?":
        "您能提供有关正义及其与社会关系的深刻见解吗？",
      "What lessons does Thirukural offer on the importance of compassion and its relationship to justice?":
        "关于同情心的重要性及其与正义的关系，蒂鲁古拉尔提供了哪些教训？",
      "How does Thirukural address the theme of knowledge and its relationship to science and technology?":
        "蒂鲁库拉尔如何阐述知识及其与科学技术的关系这一主题？",
      "What lessons does Thirukural offer on the importance of humility and its relationship to knowledge?":
        "关于工作的重要性及其与知识的关系，蒂鲁库拉尔教授了哪些教训？",
      "Can you provide Thirukural's insights on the concept of beauty and its relationship to art and creativity?":
        "您能提供蒂鲁库拉尔对美的概念及其与艺术和创造力的关系的见解吗？",
      "What lessons does Thirukural offer on the importance of integrity and its relationship to art?":
        "关于诚信的重要性及其与艺术的关系，蒂鲁古拉尔提供了哪些教训？",
    },
    german: {
      Preface: "Vorwort",
      "Domestic Virtue": "Häusliche Tugend",
      "Ascetic Virtue": "Asketische Tugend",
      Royalty: "Königtum",
      Ministry: "Ministerium",
      Politics: "Politik",
      Friendship: "Freundschaft",
      Miscelleanous: "Verschiedenes",
      "Pre-marital love": "Voreheliche Liebe",
      "Post-marital love": "Nacheheliche Liebe",
      "Love and Relationships": "Liebe, Beziehungen",
      "Personal Growth": "Persönliche Entwicklung",
      "Leadership and Success": "Führung, Erfolg",
      "Philosophy and Nature": "Philosophie, Natur",
      "Career and Finance": "Industrie, Finanzen",
      "Health and Wellness": "Gesundheit, Gesundheit",
      "Ethics and Morality": "Ethik, Moral",
      "Religion and Spirituality": "Religion, Spiritualität",
      "Politics and Society": "Politik, Gesellschaft",
      "Science and Technology": "Wissenschaft, Technologie",
      "Art and Creativity": "Kunst, Kultur",
      "How does Thirukural define true love and relationships?":
        "Wie definiert Thirukkural wahre Liebe und Beziehungen?",
      "What are Thirukural's views on the role of women in society?":
        "Was waren Thirukkurals Ansichten zur Rolle der Frau in der Gesellschaft?",
      "How does Thirukural address the theme of love and its relationship to human emotions?":
        "Wie geht Thirukkural auf das Thema Liebe und ihre Beziehung zu menschlichen Emotionen ein?",
      "What advice does Thirukural offer for overcoming adversity?":
        "Welchen Rat gibt Tirukkural, um Widrigkeiten zu überwinden?",
      "What lessons does Thirukural offer on the importance of humility?":
        "Welche Lektionen lehrt Tirukkural über die Bedeutung von Demut?",
      "How does Thirukural address the theme of knowledge and its pursuit?":
        "Wie bezieht sich Tirukkural auf Wissen und seinen Zweck?",
      "Can you provide Thirukural's insights on effective leadership?":
        "Können Sie entscheidende Einblicke in effektive Führung geben?",
      "What lessons does Thirukural offer on handling success and failure?":
        "Welche Lehren bietet Tirukkural im Umgang mit Erfolg und Misserfolg?",
      "What are Thirukural's views on the balance between action and contemplation?":
        "Was sind Thirukkurals Ansichten zum Gleichgewicht zwischen Handeln und Denken?",
      "How does Thirukural address the theme of time and its management?":
        "Wie geht Tirukkural mit dem Thema Zeit und ihrem Management um?",
      "Can you explain Thirukural's perspective on the relationship between humans and nature?":
        "Können Sie Thirukkurals Sicht auf die Beziehung zwischen Mensch und Natur erklären?",
      "What advice does Thirukural offer for managing finances?":
        "Welche Ratschläge bietet Thirukkural für die Verwaltung der Finanzen?",
      "What lessons does Thirukural offer on the importance of hard work?":
        "Welche Lektionen lehrt Thirukkural über die Bedeutung harter Arbeit?",
      "How does Thirukural address the theme of success and its pursuit?":
        "Wie bezieht sich Thirukkural auf das Thema Sieg und seinen Zweck?",
      "How does Thirukural address the theme of health and its importance?":
        "Wie geht Thirukkural mit der Gesundheit und ihrer Bedeutung um?",
      "What lessons does Thirukural offer on the balance between work and rest?":
        "Welche Lehren lehrt Thirukkural über die Balance zwischen Arbeit und Freizeit?",
      "Can you provide Thirukural's insights on the concept of duty and its relationship to morality?":
        "Können Sie aufschlussreiche Einblicke in den Pflichtbegriff und seinen Zusammenhang mit der Moral geben?",
      "What lessons does Thirukural offer on the importance of integrity and honesty?":
        "Welche Lektionen lehrt Thirukkural über die Bedeutung von Integrität und Ehrlichkeit?",
      "How does Thirukural address the theme of faith and its relationship to spirituality?":
        "Wie geht Thirukkural mit dem Thema Glauben und seiner Beziehung zur Spiritualität um?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to faith?":
        "Welche Lehren lehrt Tirukkural über die Bedeutung von Demut und ihre Beziehung zum Glauben?",
      "Can you provide Thirukural's insights on the concept of justice and its relationship to society?":
        "Können Sie aufschlussreiche Einblicke in die Gerechtigkeit und ihre Beziehung zur Gesellschaft geben?",
      "What lessons does Thirukural offer on the importance of compassion and its relationship to justice?":
        "Welche Lehren bietet Thirukkural über die Bedeutung von Mitgefühl und seine Beziehung zur Gerechtigkeit?",
      "How does Thirukural address the theme of knowledge and its relationship to science and technology?":
        "Wie geht Thirukkural mit dem Thema Wissen und seiner Beziehung zu Wissenschaft und Technologie um?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to knowledge?":
        "Welche Lehren lehrt Thirukkural über die Bedeutung der Arbeit und ihren Zusammenhang mit Wissen?",
      "Can you provide Thirukural's insights on the concept of beauty and its relationship to art and creativity?":
        "Können Sie Thirukkurals Einblicke in das Konzept der Schönheit und seinen Zusammenhang mit Kunst und Kreativität geben?",
      "What lessons does Thirukural offer on the importance of integrity and its relationship to art?":
        "Welche Lehren bietet Thirukkural über die Bedeutung von Integrität und ihre Beziehung zur Kunst?",
    },
    korean: {
      Preface: "서문",
      "Domestic Virtue": "가정의 미덕",
      "Ascetic Virtue": "금욕의 미덕",
      Royalty: "왕권",
      Ministry: "부처",
      Politics: "정치",
      Friendship: "우정",
      Miscelleanous: "기타",
      "Pre-marital love": "혼전 사랑",
      "Post-marital love": "혼후 사랑",
      "Love and Relationships": "사랑, 관계",
      "Personal Growth": "개인 개발",
      "Leadership and Success": "리더십, 성공",
      "Philosophy and Nature": "철학, 자연",
      "Career and Finance": "산업, 금융",
      "Health and Wellness": "건강, 건강",
      "Ethics and Morality": "윤리, 도덕",
      "Religion and Spirituality": "종교, 영성",
      "Politics and Society": "정치, 사회",
      "Science and Technology": "과학, 기술",
      "Art and Creativity": "예술, 문화",
      "How does Thirukural define true love and relationships?":
        "Thirukkural은 진정한 사랑과 관계를 어떻게 정의합니까?",
      "What are Thirukural's views on the role of women in society?":
        "사회에서 여성의 역할에 대한 Thirukkural의 견해는 무엇이었습니까?",
      "How does Thirukural address the theme of love and its relationship to human emotions?":
        "Thirukkural은 사랑이라는 주제와 인간 감정과의 관계를 어떻게 다루나요?",
      "What advice does Thirukural offer for overcoming adversity?":
        "역경을 극복하기 위해 티루쿠랄은 어떤 조언을 합니까?",
      "What lessons does Thirukural offer on the importance of humility?":
        "티루쿠랄은 겸손의 중요성에 대해 어떤 교훈을 가르치는가?",
      "How does Thirukural address the theme of knowledge and its pursuit?":
        "Tirukkural은 지식과 그 목적을 어떻게 지칭합니까?",
      "Can you provide Thirukural's insights on effective leadership?":
        "효과적인 리더십에 대한 중요한 통찰력을 제공할 수 있습니까?",
      "What lessons does Thirukural offer on handling success and failure?":
        "티루쿠랄은 성공과 실패를 다루면서 어떤 교훈을 제공합니까?",
      "What are Thirukural's views on the balance between action and contemplation?":
        "행동과 생각의 균형에 대한 Thirukkural의 견해는 무엇입니까?",
      "How does Thirukural address the theme of time and its management?":
        "Tirukkural은 시간과 그 관리라는 주제를 어떻게 다루나요?",
      "Can you explain Thirukural's perspective on the relationship between humans and nature?":
        "인간과 자연의 관계에 대한 Thirukkural의 관점을 설명할 수 있습니까?",
      "What advice does Thirukural offer for managing finances?":
        "Thirukkural은 재정 관리에 대해 어떤 조언을 제공합니까?",
      "What lessons does Thirukural offer on the importance of hard work?":
        "Thirukkural은 열심히 일하는 것의 중요성에 대해 어떤 교훈을 가르치나요?",
      "How does Thirukural address the theme of success and its pursuit?":
        "Thirukkural은 승리라는 주제와 그 목적을 어떻게 언급합니까?",
      "How does Thirukural address the theme of health and its importance?":
        "Thirukkural은 건강과 그 중요성을 어떻게 다루나요?",
      "What lessons does Thirukural offer on the balance between work and rest?":
        "Thirukkural은 일과 여가의 균형에 관해 어떤 교훈을 가르치는가?",
      "Can you provide Thirukural's insights on the concept of duty and its relationship to morality?":
        "의무의 개념과 도덕과의 관계에 대한 통찰력 있는 통찰력을 제공할 수 있습니까?",
      "What lessons does Thirukural offer on the importance of integrity and honesty?":
        "Thirukkural은 진실성과 정직의 중요성에 대해 어떤 교훈을 가르치나요?",
      "How does Thirukural address the theme of faith and its relationship to spirituality?":
        "Thirukkural은 신앙의 주제와 영성과의 관계를 어떻게 다루나요?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to faith?":
        "티루쿠랄은 겸손의 중요성과 신앙과의 관계에 대해 어떤 교훈을 가르치는가?",
      "Can you provide Thirukural's insights on the concept of justice and its relationship to society?":
        "정의와 사회와의 관계에 대한 통찰력 있는 통찰력을 제공해 주실 수 있나요?",
      "What lessons does Thirukural offer on the importance of compassion and its relationship to justice?":
        "Thirukkural은 연민의 중요성과 정의와의 관계에 대해 어떤 교훈을 제공합니까?",
      "How does Thirukural address the theme of knowledge and its relationship to science and technology?":
        "Thirukkural은 지식이라는 주제와 과학 및 기술과의 관계를 어떻게 다루나요?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to knowledge?":
        "Thirukkural은 일의 중요성과 지식과의 관계에 대해 어떤 교훈을 가르치는가?",
      "Can you provide Thirukural's insights on the concept of beauty and its relationship to art and creativity?":
        "미의 개념과 예술 및 창의성과의 관계에 대한 Thirukkural의 통찰력을 제공할 수 있습니까?",
      "What lessons does Thirukural offer on the importance of integrity and its relationship to art?":
        "Thirukkural은 진실성의 중요성과 예술과의 관계에 대해 어떤 교훈을 제공합니까?",
    },
    malay: {
      Preface: "Prakata",
      "Domestic Virtue": "Kebajikan Domestik",
      "Ascetic Virtue": "Kebajikan Pertapaan",
      Royalty: "Kerajaan",
      Ministry: "Kementerian",
      Politics: "Politik",
      Friendship: "Persahabatan",
      Miscelleanous: "Pelbagai",
      "Pre-marital love": "Cinta Pra Perkahwinan",
      "Post-marital love": "Cinta Pasca Perkahwinan",
      "Love and Relationships": "Cinta, Hubungan",
      "Personal Growth": "Pembangunan Diri",
      "Leadership and Success": "Kepimpinan, Kejayaan",
      "Philosophy and Nature": "Falsafah, Alam Semula Jadi",
      "Career and Finance": "Industri, Kewangan",
      "Health and Wellness": "Kesihatan, Kesihatan",
      "Ethics and Morality": "Etika, Moral",
      "Religion and Spirituality": "Agama, Kerohanian",
      "Politics and Society": "Politik, Masyarakat",
      "Science and Technology": "Sains, Teknologi",
      "Art and Creativity": "Seni, Budaya",
      "How does Thirukural define true love and relationships?":
        "Bagaimanakah Thirukkural mentakrifkan cinta dan perhubungan sejati?",
      "What are Thirukural's views on the role of women in society?":
        "Apakah pandangan Thirukkural tentang peranan wanita dalam masyarakat?",
      "How does Thirukural address the theme of love and its relationship to human emotions?":
        "Bagaimanakah Thirukkural menangani tema cinta dan hubungannya dengan emosi manusia?",
      "What advice does Thirukural offer for overcoming adversity?":
        "Nasihat apa yang Tirukkural berikan untuk mengatasi kesukaran?",
      "What lessons does Thirukural offer on the importance of humility?":
        "Apakah pengajaran yang Tirukkural ajar tentang pentingnya kerendahan hati?",
      "How does Thirukural address the theme of knowledge and its pursuit?":
        "Bagaimana Tirukkural merujuk kepada ilmu dan tujuannya?",
      "Can you provide Thirukural's insights on effective leadership?":
        "Bolehkah anda memberikan pandangan kritikal tentang kepimpinan yang berkesan?",
      "What lessons does Thirukural offer on handling success and failure?":
        "Apakah pengajaran yang ditawarkan oleh Tirukkural dalam menangani kejayaan dan kegagalan?",
      "What are Thirukural's views on the balance between action and contemplation?":
        "Apakah pandangan Thirukkural tentang keseimbangan antara tindakan dan pemikiran?",
      "How does Thirukural address the theme of time and its management?":
        "Bagaimana Tirukkural menangani tema masa dan pengurusannya?",
      "Can you explain Thirukural's perspective on the relationship between humans and nature?":
        "Bolehkah anda menjelaskan perspektif Thirukkural tentang hubungan antara manusia dan alam semula jadi?",
      "What advice does Thirukural offer for managing finances?":
        "Nasihat apa yang Thirukkural tawarkan untuk menguruskan kewangan?",
      "What lessons does Thirukural offer on the importance of hard work?":
        "Apakah pengajaran yang Thirukkural ajar tentang kepentingan kerja keras?",
      "How does Thirukural address the theme of success and its pursuit?":
        "Bagaimana Thirukkural merujuk kepada tema kemenangan dan tujuannya?",
      "How does Thirukural address the theme of health and its importance?":
        "Bagaimanakah Thirukkural menangani kesihatan dan kepentingannya?",
      "What lessons does Thirukural offer on the balance between work and rest?":
        "Apakah pengajaran yang Thirukkural ajar tentang keseimbangan antara kerja dan masa lapang?",
      "Can you provide Thirukural's insights on the concept of duty and its relationship to morality?":
        "Bolehkah anda memberikan pandangan yang mendalam tentang konsep kewajipan dan hubungannya dengan moral?",
      "What lessons does Thirukural offer on the importance of integrity and honesty?":
        "Apakah pengajaran yang Thirukkural ajar tentang kepentingan integriti dan kejujuran?",
      "How does Thirukural address the theme of faith and its relationship to spirituality?":
        "Bagaimanakah Thirukkural menangani tema iman dan hubungannya dengan kerohanian?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to faith?":
        "Apakah pengajaran yang Tirukkural ajar tentang kepentingan kerendahan hati dan hubungannya dengan iman?",
      "Can you provide Thirukural's insights on the concept of justice and its relationship to society?":
        "Bolehkah anda memberikan pandangan yang mendalam tentang keadilan dan hubungannya dengan masyarakat?",
      "What lessons does Thirukural offer on the importance of compassion and its relationship to justice?":
        "Apakah pengajaran yang Thirukkural tawarkan tentang kepentingan belas kasihan dan hubungannya dengan keadilan?",
      "How does Thirukural address the theme of knowledge and its relationship to science and technology?":
        "Bagaimanakah Thirukkural menangani tema pengetahuan dan kaitannya dengan sains dan teknologi?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to knowledge?":
        "Apakah pengajaran yang Thirukkural ajar tentang kepentingan kerja dan kaitannya dengan pengetahuan?",
      "Can you provide Thirukural's insights on the concept of beauty and its relationship to art and creativity?":
        "Bolehkah anda memberikan pandangan Thirukkural tentang konsep kecantikan dan kaitannya dengan seni dan kreativiti?",
      "What lessons does Thirukural offer on the importance of integrity and its relationship to art?":
        "Apakah pengajaran yang ditawarkan oleh Thirukkural tentang kepentingan integriti dan hubungannya dengan seni?",
    },
    malayalam: {
      Preface: "ആമുഖം",
      "Domestic Virtue": "കുടുംബ സദ്ഗുണം",
      "Ascetic Virtue": "സന്യാസ സദ്ഗുണം",
      Royalty: "രാജത്വം",
      Ministry: "മന്ത്രാലയം",
      Politics: "രാഷ്ട്രീയം",
      Friendship: "സൗഹൃദം",
      Miscelleanous: "പലവക",
      "Pre-marital love": "വിവാഹപൂർവ്വ പ്രണയം",
      "Post-marital love": "വിവാഹാനന്തര പ്രണയം",
      "Love and Relationships": "സ്നേഹം, ബന്ധങ്ങൾ",
      "Personal Growth": "വ്യക്തിഗത വികസനം",
      "Leadership and Success": "നേതൃത്വം, വിജയം",
      "Philosophy and Nature": "തത്ത്വചിന്ത, പ്രകൃതി",
      "Career and Finance": "വ്യവസായം, ധനകാര്യം",
      "Health and Wellness": "ആരോഗ്യം, ആരോഗ്യം",
      "Ethics and Morality": "ധാർമ്മികത, ധാർമ്മികത",
      "Religion and Spirituality": "മതം, ആത്മീയത",
      "Politics and Society": "രാഷ്ട്രീയം, സമൂഹം",
      "Science and Technology": "ശാസ്ത്രം, സാങ്കേതികവിദ്യ",
      "Art and Creativity": "കല, സംസ്കാരം",
      "How does Thirukural define true love and relationships?":
        "തിരുക്കുറൽ എങ്ങനെയാണ് യഥാർത്ഥ സ്നേഹത്തെയും ബന്ധങ്ങളെയും നിർവചിക്കുന്നത്?",
      "What are Thirukural's views on the role of women in society?":
        "സമൂഹത്തിൽ സ്ത്രീകളുടെ പങ്കിനെക്കുറിച്ചുള്ള തിരുക്കുറലിൻ്റെ വീക്ഷണങ്ങൾ എന്തായിരുന്നു?",
      "How does Thirukural address the theme of love and its relationship to human emotions?":
        "തിരുക്കുറൽ പ്രണയത്തിൻ്റെ പ്രമേയത്തെയും മനുഷ്യവികാരങ്ങളുമായുള്ള അതിൻ്റെ ബന്ധത്തെയും എങ്ങനെ അഭിസംബോധന ചെയ്യുന്നു?",
      "What advice does Thirukural offer for overcoming adversity?":
        "പ്രതിസന്ധികളെ തരണം ചെയ്യാൻ തിരുക്കുറൾ എന്ത് ഉപദേശമാണ് നൽകുന്നത്?",
      "What lessons does Thirukural offer on the importance of humility?":
        "എളിമയുടെ പ്രാധാന്യത്തെക്കുറിച്ച് തിരുക്കുറൾ എന്ത് പാഠങ്ങളാണ് പഠിപ്പിക്കുന്നത്?",
      "How does Thirukural address the theme of knowledge and its pursuit?":
        "തിരുക്കുറൽ എങ്ങനെയാണ് അറിവിനെയും അതിൻ്റെ ഉദ്ദേശത്തെയും സൂചിപ്പിക്കുന്നത്?",
      "Can you provide Thirukural's insights on effective leadership?":
        "ഫലപ്രദമായ നേതൃത്വത്തെക്കുറിച്ച് നിങ്ങൾക്ക് നിർണായക ഉൾക്കാഴ്ചകൾ നൽകാൻ കഴിയുമോ?",
      "What lessons does Thirukural offer on handling success and failure?":
        "വിജയവും പരാജയവും കൈകാര്യം ചെയ്യുന്നതിൽ തിരുക്കുറൽ എന്ത് പാഠങ്ങളാണ് നൽകുന്നത്?",
      "What are Thirukural's views on the balance between action and contemplation?":
        "പ്രവർത്തനവും ചിന്തയും തമ്മിലുള്ള സന്തുലിതാവസ്ഥയെക്കുറിച്ചുള്ള തിരുക്കുറലിൻ്റെ വീക്ഷണങ്ങൾ എന്തൊക്കെയാണ്?",
      "How does Thirukural address the theme of time and its management?":
        "തിരുക്കുറൽ സമയത്തെയും അതിൻ്റെ പരിപാലനത്തെയും എങ്ങനെ അഭിസംബോധന ചെയ്യുന്നു?",
      "Can you explain Thirukural's perspective on the relationship between humans and nature?":
        "മനുഷ്യരും പ്രകൃതിയും തമ്മിലുള്ള ബന്ധത്തെക്കുറിച്ചുള്ള തിരുക്കുറലിൻ്റെ വീക്ഷണം വിശദീകരിക്കാമോ?",
      "What advice does Thirukural offer for managing finances?":
        "ധനകാര്യങ്ങൾ കൈകാര്യം ചെയ്യുന്നതിന് തിരുക്കുറൾ എന്ത് ഉപദേശമാണ് നൽകുന്നത്?",
      "What lessons does Thirukural offer on the importance of hard work?":
        "കഠിനാധ്വാനത്തിൻ്റെ പ്രാധാന്യത്തെക്കുറിച്ച് തിരുക്കുറൾ എന്ത് പാഠങ്ങളാണ് പഠിപ്പിക്കുന്നത്?",
      "How does Thirukural address the theme of success and its pursuit?":
        "തിരുക്കുറൽ വിജയത്തിൻ്റെ പ്രമേയത്തെയും അതിൻ്റെ ലക്ഷ്യത്തെയും എങ്ങനെ പരാമർശിക്കുന്നു?",
      "How does Thirukural address the theme of health and its importance?":
        "തിരുക്കുറൽ എങ്ങനെയാണ് ആരോഗ്യത്തെയും അതിൻ്റെ പ്രാധാന്യത്തെയും അഭിസംബോധന ചെയ്യുന്നത്?",
      "What lessons does Thirukural offer on the balance between work and rest?":
        "ജോലിയും ഒഴിവുസമയവും തമ്മിലുള്ള സന്തുലിതാവസ്ഥയെക്കുറിച്ച് തിരുക്കുറൾ എന്ത് പാഠങ്ങളാണ് പഠിപ്പിക്കുന്നത്?",
      "Can you provide Thirukural's insights on the concept of duty and its relationship to morality?":
        "കടമ എന്ന ആശയത്തെക്കുറിച്ചും ധാർമികതയുമായുള്ള ബന്ധത്തെക്കുറിച്ചും നിങ്ങൾക്ക് ഉൾക്കാഴ്ചയുള്ള ഉൾക്കാഴ്ചകൾ നൽകാൻ കഴിയുമോ?",
      "What lessons does Thirukural offer on the importance of integrity and honesty?":
        "സത്യസന്ധതയുടെയും സത്യസന്ധതയുടെയും പ്രാധാന്യത്തെക്കുറിച്ച് തിരുക്കുറൾ എന്ത് പാഠങ്ങളാണ് പഠിപ്പിക്കുന്നത്?",
      "How does Thirukural address the theme of faith and its relationship to spirituality?":
        "വിശ്വാസത്തിൻ്റെ പ്രമേയത്തെയും ആത്മീയതയുമായുള്ള അതിൻ്റെ ബന്ധത്തെയും തിരുക്കുറൽ എങ്ങനെയാണ് അഭിസംബോധന ചെയ്യുന്നത്?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to faith?":
        "എളിമയുടെ പ്രാധാന്യത്തെക്കുറിച്ചും വിശ്വാസവുമായുള്ള ബന്ധത്തെക്കുറിച്ചും തിരുക്കുറൾ എന്ത് പാഠങ്ങളാണ് പഠിപ്പിക്കുന്നത്?",
      "Can you provide Thirukural's insights on the concept of justice and its relationship to society?":
        "നീതിയെയും സമൂഹവുമായുള്ള അതിൻ്റെ ബന്ധത്തെയും കുറിച്ച് നിങ്ങൾക്ക് ഉൾക്കാഴ്ചയുള്ള ഉൾക്കാഴ്ചകൾ നൽകാൻ കഴിയുമോ?",
      "What lessons does Thirukural offer on the importance of compassion and its relationship to justice?":
        "കരുണയുടെ പ്രാധാന്യത്തെക്കുറിച്ചും നീതിയുമായുള്ള ബന്ധത്തെക്കുറിച്ചും തിരുക്കുറൾ എന്ത് പാഠങ്ങളാണ് നൽകുന്നത്?",
      "How does Thirukural address the theme of knowledge and its relationship to science and technology?":
        "വിജ്ഞാനത്തിൻ്റെ പ്രമേയത്തെയും ശാസ്ത്ര സാങ്കേതിക വിദ്യയുമായുള്ള അതിൻ്റെ ബന്ധത്തെയും തിരുക്കുറൽ എങ്ങനെയാണ് അഭിസംബോധന ചെയ്യുന്നത്?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to knowledge?":
        "ജോലിയുടെ പ്രാധാന്യത്തെക്കുറിച്ചും അറിവിനോടുള്ള ബന്ധത്തെക്കുറിച്ചും തിരുക്കുറൾ എന്ത് പാഠങ്ങളാണ് പഠിപ്പിക്കുന്നത്?",
      "Can you provide Thirukural's insights on the concept of beauty and its relationship to art and creativity?":
        "സൗന്ദര്യ സങ്കൽപ്പത്തെക്കുറിച്ചും കലയോടും സർഗ്ഗാത്മകതയോടുമുള്ള ബന്ധത്തെക്കുറിച്ചും തിരുക്കുറലിൻ്റെ ഉൾക്കാഴ്ചകൾ നിങ്ങൾക്ക് നൽകാമോ?",
      "What lessons does Thirukural offer on the importance of integrity and its relationship to art?":
        "സമഗ്രതയുടെ പ്രാധാന്യത്തെക്കുറിച്ചും കലയുമായുള്ള അതിൻ്റെ ബന്ധത്തെക്കുറിച്ചും തിരുക്കുറൽ എന്ത് പാഠങ്ങളാണ് നൽകുന്നത്?",
    },
    polish: {
      Preface: "Przedmowa",
      "Domestic Virtue": "Cnota domowa",
      "Ascetic Virtue": "Cnota ascetyczna",
      Royalty: "Królewskość",
      Ministry: "Ministerstwo",
      Politics: "Polityka",
      Friendship: "Przyjaźń",
      Miscelleanous: "Różne",
      "Pre-marital love": "Miłość przedmałżeńska",
      "Post-marital love": "Miłość pomałżeńska",
      "Love and Relationships": "Miłość, Związki",
      "Personal Growth": "Rozwój Osobisty",
      "Leadership and Success": "Przywództwo, Sukces",
      "Philosophy and Nature": "Filozofia, Natura",
      "Career and Finance": "Przemysł, Finanse",
      "Health and Wellness": "Zdrowie, zdrowie",
      "Ethics and Morality": "Etyka, Moralność",
      "Religion and Spirituality": "Religia, duchowość",
      "Politics and Society": "Polityka, Społeczeństwo",
      "Science and Technology": "Nauka, Technologia",
      "Art and Creativity": "Sztuka, kultura",
      "How does Thirukural define true love and relationships?":
        "Jak Thirukkural definiuje prawdziwą miłość i relacje?",
      "What are Thirukural's views on the role of women in society?":
        "Jakie były poglądy Thirukkurala na temat roli kobiet w społeczeństwie?",
      "How does Thirukural address the theme of love and its relationship to human emotions?":
        "W jaki sposób Thirukkural porusza temat miłości i jej związku z ludzkimi emocjami?",
      "What advice does Thirukural offer for overcoming adversity?":
        "Jakich rad udziela Tirukkural, jak pokonać przeciwności losu?",
      "What lessons does Thirukural offer on the importance of humility?":
        "Jakich lekcji Tirukkural uczy o znaczeniu pokory?",
      "How does Thirukural address the theme of knowledge and its pursuit?":
        "W jaki sposób Tirukkural odnosi się do wiedzy i jej celu?",
      "Can you provide Thirukural's insights on effective leadership?":
        "Czy możesz dostarczyć wnikliwych spostrzeżeń na temat skutecznego przywództwa?",
      "What lessons does Thirukural offer on handling success and failure?":
        "Jakich lekcji oferuje Thirukkural w radzeniu sobie z sukcesem i porażką?",
      "What are Thirukural's views on the balance between action and contemplation?":
        "Jakie były poglądy Thirukkurala na temat równowagi między działaniem a myśleniem?",
      "How does Thirukural address the theme of time and its management?":
        "W jaki sposób Tirukkural podejmuje temat czasu i zarządzania nim?",
      "Can you explain Thirukural's perspective on the relationship between humans and nature?":
        "Czy możesz wyjaśnić punkt widzenia Thirukkurala na temat relacji między człowiekiem a naturą?",
      "What advice does Thirukural offer for managing finances?":
        "Jakich rad oferuje Thirukkural w zakresie zarządzania finansami?",
      "What lessons does Thirukural offer on the importance of hard work?":
        "Jakich lekcji Thirukkural uczy o znaczeniu ciężkiej pracy?",
      "How does Thirukural address the theme of success and its pursuit?":
        "W jaki sposób Thirukkural odnosi się do tematu zwycięstwa i jego celu?",
      "How does Thirukural address the theme of health and its importance?":
        "Jak Tirukkural odnosi się do zdrowia i jego znaczenia?",
      "What lessons does Thirukural offer on the balance between work and rest?":
        "Jakich lekcji Thirukkural uczy na temat równowagi między pracą a czasem wolnym?",
      "Can you provide Thirukural's insights on the concept of duty and its relationship to morality?":
        "Czy możesz przedstawić wnikliwy wgląd w koncepcję obowiązku i jego związek z moralnością?",
      "What lessons does Thirukural offer on the importance of integrity and honesty?":
        "Jakich lekcji Thirukkural uczy na temat znaczenia uczciwości i uczciwości?",
      "How does Thirukural address the theme of faith and its relationship to spirituality?":
        "W jaki sposób Thirukkural odnosi się do tematu wiary i jej związku z duchowością?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to faith?":
        "Jakich lekcji Tirukkural uczy na temat znaczenia pokory i jej związku z wiarą?",
      "Can you provide Thirukural's insights on the concept of justice and its relationship to society?":
        "Czy możesz przedstawić wnikliwy wgląd w sprawiedliwość i jej związek ze społeczeństwem?",
      "What lessons does Thirukural offer on the importance of compassion and its relationship to justice?":
        "Jakich lekcji Thirukkural oferuje na temat znaczenia współczucia i jego związku ze sprawiedliwością?",
      "How does Thirukural address the theme of knowledge and its relationship to science and technology?":
        "W jaki sposób Thirukkural podejmuje temat wiedzy i jej związku z nauką i technologią?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to knowledge?":
        "Jakich lekcji Tirukkural uczy na temat znaczenia pracy i jej związku z wiedzą?",
      "Can you provide Thirukural's insights on the concept of beauty and its relationship to art and creativity?":
        "Czy możesz przedstawić spostrzeżenia Thirukkurala na temat koncepcji piękna i jego związku ze sztuką i kreatywnością?",
      "What lessons does Thirukural offer on the importance of integrity and its relationship to art?":
        "Jakich lekcji Thirukkural oferuje na temat znaczenia uczciwości i jej związku ze sztuką?",
    },
    russian: {
      Preface: "Предисловие",
      "Domestic Virtue": "Домашняя добродетель",
      "Ascetic Virtue": "Аскетическая добродетель",
      Royalty: "Королевская власть",
      Ministry: "Министерство",
      Politics: "Политика",
      Friendship: "Дружба",
      Miscelleanous: "Разное",
      "Pre-marital love": "Добрачная любовь",
      "Post-marital love": "Послебрачная любовь",
      "Love and Relationships": "Любовь, Отношения",
      "Personal Growth": "Личностное развитие",
      "Leadership and Success": "Лидерство, Успех",
      "Philosophy and Nature": "Философия, Природа",
      "Career and Finance": "Промышленность, Финансы",
      "Health and Wellness": "Здоровье, здоровье",
      "Ethics and Morality": "Этика, мораль",
      "Religion and Spirituality": "Религия, Духовность",
      "Politics and Society": "Политика, Общество",
      "Science and Technology": "Наука, технологии",
      "Art and Creativity": "Искусство, Культура",
      "How does Thirukural define true love and relationships?":
        "Как Тируккурал определяет настоящую любовь и отношения?",
      "What are Thirukural's views on the role of women in society?":
        "Каковы были взгляды Тируккурала на роль женщины в обществе?",
      "How does Thirukural address the theme of love and its relationship to human emotions?":
        "Как Тируккурал обращается к теме любви и ее связи с человеческими эмоциями?",
      "What advice does Thirukural offer for overcoming adversity?":
        "Какой совет дает Тируккурал, чтобы преодолеть невзгоды?",
      "What lessons does Thirukural offer on the importance of humility?":
        "Какие уроки Тируккурал преподает о важности смирения?",
      "How does Thirukural address the theme of knowledge and its pursuit?":
        "Как Тируккурал относится к знанию и его цели?",
      "Can you provide Thirukural's insights on effective leadership?":
        "Можете ли вы дать критическую оценку эффективному лидерству?",
      "What lessons does Thirukural offer on handling success and failure?":
        "Какие уроки предлагает Тируккурал, как справиться с успехом и неудачей?",
      "What are Thirukural's views on the balance between action and contemplation?":
        "Каковы взгляды Тируккурала на баланс между действием и мыслью?",
      "How does Thirukural address the theme of time and its management?":
        "Как Тируккурал рассматривает тему времени и управления им?",
      "Can you explain Thirukural's perspective on the relationship between humans and nature?":
        "Можете ли вы объяснить точку зрения Тируккурала на отношения между людьми и природой?",
      "What advice does Thirukural offer for managing finances?":
        "Какой совет дает Тируккурал по управлению финансами?",
      "What lessons does Thirukural offer on the importance of hard work?":
        "Какие уроки Тируккурал преподает о важности упорного труда?",
      "How does Thirukural address the theme of success and its pursuit?":
        "Как Тируккурал относится к теме победы и ее цели?",
      "How does Thirukural address the theme of health and its importance?":
        "Как Тируккурал относится к здоровью и его важности?",
      "What lessons does Thirukural offer on the balance between work and rest?":
        "Какие уроки Тируккурал преподает о балансе между работой и отдыхом?",
      "Can you provide Thirukural's insights on the concept of duty and its relationship to morality?":
        "Можете ли вы дать глубокое понимание концепции долга и его связи с моралью?",
      "What lessons does Thirukural offer on the importance of integrity and honesty?":
        "Какие уроки Тируккурал преподает о важности порядочности и честности?",
      "How does Thirukural address the theme of faith and its relationship to spirituality?":
        "Как Тируккурал обращается к теме веры и ее связи с духовностью?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to faith?":
        "Какие уроки преподает Тируккурал о важности смирения и его связи с верой?",
      "Can you provide Thirukural's insights on the concept of justice and its relationship to society?":
        "Можете ли вы дать глубокую информацию о правосудии и его взаимосвязи с обществом?",
      "What lessons does Thirukural offer on the importance of compassion and its relationship to justice?":
        "Какие уроки предлагает Тируккурал о важности сострадания и его связи со справедливостью?",
      "How does Thirukural address the theme of knowledge and its relationship to science and technology?":
        "Как Тируккурал рассматривает тему знаний и их связь с наукой и технологиями?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to knowledge?":
        "Какие уроки преподает Тируккурал о важности работы и ее связи со знаниями?",
      "Can you provide Thirukural's insights on the concept of beauty and its relationship to art and creativity?":
        "Можете ли вы поделиться взглядами Тируккурала на концепцию красоты и ее связь с искусством и творчеством?",
      "What lessons does Thirukural offer on the importance of integrity and its relationship to art?":
        "Какие уроки предлагает Тируккурал о важности честности и ее связи с искусством?",
    },
    singalam: {
      Preface: "පෙරවදන",
      "Domestic Virtue": "ගෘහස්ථ ගුණය",
      "Ascetic Virtue": "තපස් ගුණය",
      Royalty: "රාජත්වය",
      Ministry: "අමාත්යාංශය",
      Politics: "දේශපාලනය",
      Friendship: "මිත්රත්වය",
      Miscelleanous: "විවිධ",
      "Pre-marital love": "විවාහයට පෙර ආදරය",
      "Post-marital love": "විවාහයෙන් පසු ආදරය",
      "Love and Relationships": "අන්පු, සබඳතා",
      "Personal Growth": "තනිවූ වර්ධනය",
      "Leadership and Success": "තලයිමයි, ජය",
      "Philosophy and Nature": "තත්වය, ස්වභාවික",
      "Career and Finance": "තොල්, නිති",
      "Health and Wellness": "සුගාදරම්, සෞඛ්‍යය",
      "Ethics and Morality": "නීතිවිද්‍යා, ආරණේ",
      "Religion and Spirituality": "මතම්, අධ්‍යාත්මික",
      "Politics and Society": "අරසික, සමාජය",
      "Science and Technology": "අඥාන, තාක්ෂණය",
      "Art and Creativity": "කලයි, සංස්කෘතිය",
      "How does Thirukural define true love and relationships?":
        "තිරුක්කුරල් සැබෑ ආදරය සහ සබඳතා නිර්වචනය කරන්නේ කෙසේද?",
      "What are Thirukural's views on the role of women in society?":
        "සමාජයේ කාන්තාවන්ගේ භූමිකාව පිළිබඳ තිරුක්කුරල්ගේ අදහස් මොනවාද?",
      "How does Thirukural address the theme of love and its relationship to human emotions?":
        "තිරුක්කුරල් ප්‍රේමයේ තේමාව සහ එහි මානව හැඟීම් සමඟ ඇති සම්බන්ධය ආමන්ත්‍රණය කරන්නේ කෙසේද?",
      "What advice does Thirukural offer for overcoming adversity?":
        "විපත්ති ජය ගැනීමට තිරුක්කුරල් දෙන උපදෙස කුමක්ද?",
      "What lessons does Thirukural offer on the importance of humility?":
        "නිහතමානීකමේ වැදගත්කම ගැන තිරුක්කුරල් උගන්වන පාඩම් මොනවාද?",
      "How does Thirukural address the theme of knowledge and its pursuit?":
        "තිරුක්කුරල් දැනුම සහ එහි අරමුණ ගැන සඳහන් කරන්නේ කෙසේද?",
      "Can you provide Thirukural's insights on effective leadership?":
        "ඔබට ඵලදායී නායකත්වය පිළිබඳ විවේචනාත්මක අවබෝධයක් ලබා දිය හැකිද?",
      "What lessons does Thirukural offer on handling success and failure?":
        "සාර්ථකත්වය සහ අසාර්ථකත්වය සමඟ කටයුතු කිරීමේදී තිරුක්කුරල් ලබා දෙන පාඩම් මොනවාද?",
      "What are Thirukural's views on the balance between action and contemplation?":
        "ක්‍රියාව සහ චින්තනය අතර සමතුලිතතාවය පිළිබඳ තිරුක්කුරල්ගේ අදහස් මොනවාද?",
      "How does Thirukural address the theme of time and its management?":
        "තිරුක්කුරල් කාලය සහ එහි කළමනාකරණය යන තේමාව ආමන්ත්‍රණය කරන්නේ කෙසේද?",
      "Can you explain Thirukural's perspective on the relationship between humans and nature?":
        "මිනිසුන් සහ සොබාදහම අතර සම්බන්ධය පිළිබඳ තිරුක්කුරල්ගේ ඉදිරිදර්ශනය ඔබට පැහැදිලි කළ හැකිද?",
      "What advice does Thirukural offer for managing finances?":
        "මුල්‍ය කළමනාකරණය සඳහා තිරුක්කුරල් ලබා දෙන උපදෙස් මොනවාද?",
      "What lessons does Thirukural offer on the importance of hard work?":
        "තිරුක්කුරල් වෙහෙස මහන්සි වී වැඩ කිරීමේ වැදගත්කම ගැන උගන්වන පාඩම් මොනවාද?",
      "How does Thirukural address the theme of success and its pursuit?":
        "තිරුක්කුරල් ජයග්‍රහණයේ තේමාව සහ එහි අරමුණ ගැන සඳහන් කරන්නේ කෙසේද?",
      "How does Thirukural address the theme of health and its importance?":
        "තිරුක්කුරල් සෞඛ්‍යය සහ එහි වැදගත්කම ආමන්ත්‍රණය කරන්නේ කෙසේද?",
      "What lessons does Thirukural offer on the balance between work and rest?":
        "වැඩ සහ විවේකය අතර සමතුලිතතාවය ගැන තිරුක්කුරල් උගන්වන පාඩම් මොනවාද?",
      "Can you provide Thirukural's insights on the concept of duty and its relationship to morality?":
        "ඔබට යුතුකම පිළිබඳ සංකල්පය සහ සදාචාරය සමඟ ඇති සම්බන්ධය පිළිබඳ තීක්ෂ්ණ බුද්ධිය ලබා දිය හැකිද?",
      "What lessons does Thirukural offer on the importance of integrity and honesty?":
        "අඛණ්ඩතාවයේ සහ අවංකභාවයේ වැදගත්කම ගැන තිරුක්කුරල් උගන්වන පාඩම් මොනවාද?",
      "How does Thirukural address the theme of faith and its relationship to spirituality?":
        "තිරුක්කුරල් විශ්වාසයේ තේමාව සහ අධ්‍යාත්මිකත්වයට එහි සම්බන්ධය ආමන්ත්‍රණය කරන්නේ කෙසේද?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to faith?":
        "නිහතමානිකමේ වැදගත්කම සහ ඇදහිල්ල සමඟ ඇති සම්බන්ධය ගැන තිරුක්කුරල් උගන්වන පාඩම් මොනවාද?",
      "Can you provide Thirukural's insights on the concept of justice and its relationship to society?":
        "ඔබට යුක්තිය සහ සමාජය සමඟ ඇති සම්බන්ධය පිළිබඳ තීක්ෂ්ණ බුද්ධිය ලබා දිය හැකිද?",
      "What lessons does Thirukural offer on the importance of compassion and its relationship to justice?":
        "දයානුකම්පාවේ වැදගත්කම සහ යුක්තිය සමඟ ඇති සම්බන්ධය පිළිබඳව තිරුක්කුරල් විසින් දෙන පාඩම් මොනවාද?",
      "How does Thirukural address the theme of knowledge and its relationship to science and technology?":
        "තිරුක්කුරල් දැනුමේ තේමාව සහ විද්‍යාව හා තාක්‍ෂණයට එහි සම්බන්ධය ආමන්ත්‍රණය කරන්නේ කෙසේද?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to knowledge?":
        "කාර්යයේ වැදගත්කම සහ දැනුමට ඇති සම්බන්ධය ගැන තිරුක්කුරල් උගන්වන පාඩම් මොනවාද?",
      "Can you provide Thirukural's insights on the concept of beauty and its relationship to art and creativity?":
        "සෞන්දර්යය පිළිබඳ සංකල්පය සහ කලාව සහ නිර්මාණශීලිත්වය සමඟ ඇති සම්බන්ධය පිළිබඳව ඔබට තිරුක්කුරල්ගේ තීක්ෂ්ණ බුද්ධිය ලබා දිය හැකිද?",
      "What lessons does Thirukural offer on the importance of integrity and its relationship to art?":
        "ඒකාග්‍රතාවයේ වැදගත්කම සහ කලාවට එහි ඇති සම්බන්ධය ගැන තිරුක්කුරල් දෙන පාඩම් මොනවාද?",
    },
    swedish: {
      Preface: "Förord",
      "Domestic Virtue": "Huslig dygd",
      "Ascetic Virtue": "Asketisk dygd",
      Royalty: "Kunglig värdighet",
      Ministry: "Ministerium",
      Politics: "Politik",
      Friendship: "Vänskap",
      Miscelleanous: "Diverse",
      "Pre-marital love": "Kärlek före äktenskapet",
      "Post-marital love": "Kärlek efter äktenskapet",
      "Love and Relationships": "Kärlek, relationer",
      "Personal Growth": "Personlig utveckling",
      "Leadership and Success": "Ledarskap, framgång",
      "Philosophy and Nature": "Filosofi, natur",
      "Career and Finance": "Industri, finans",
      "Health and Wellness": "Hälsa, hälsa",
      "Ethics and Morality": "Etik, moral",
      "Religion and Spirituality": "Religion, andlighet",
      "Politics and Society": "Politik, samhälle",
      "Science and Technology": "Vetenskap, teknik",
      "Art and Creativity": "Konst, kultur",
      "How does Thirukural define true love and relationships?":
        "Hur definierar Thirukkural sann kärlek och relationer?",
      "What are Thirukural's views on the role of women in society?":
        "Vad var Thirukkurals syn på kvinnors roll i samhället?",
      "How does Thirukural address the theme of love and its relationship to human emotions?":
        "Hur tar Thirukkural upp temat kärlek och dess förhållande till mänskliga känslor?",
      "What advice does Thirukural offer for overcoming adversity?":
        "Vilka råd ger Tirukkural för att övervinna motgångar?",
      "What lessons does Thirukural offer on the importance of humility?":
        "Vilka lärdomar lär Tirukkural om vikten av ödmjukhet?",
      "How does Thirukural address the theme of knowledge and its pursuit?":
        "Hur hänvisar Tirukkural till kunskap och dess syfte?",
      "Can you provide Thirukural's insights on effective leadership?":
        "Kan du ge kritiska insikter om effektivt ledarskap?",
      "What lessons does Thirukural offer on handling success and failure?":
        "Vilka lärdomar ger Tirukkural när det gäller att hantera framgång och misslyckande?",
      "What are Thirukural's views on the balance between action and contemplation?":
        "Vad är Thirukkurals syn på balansen mellan handling och tanke?",
      "How does Thirukural address the theme of time and its management?":
        "Hur tar Tirukkural upp temat tid och dess hantering?",
      "Can you explain Thirukural's perspective on the relationship between humans and nature?":
        "Kan du förklara Thirukkurals perspektiv på relationen mellan människor och natur?",
      "What advice does Thirukural offer for managing finances?":
        "Vilka råd ger Thirukkural för att hantera ekonomi?",
      "What lessons does Thirukural offer on the importance of hard work?":
        "Vilka lärdomar lär Thirukkural om vikten av hårt arbete?",
      "How does Thirukural address the theme of success and its pursuit?":
        "Hur hänvisar Thirukkural till temat seger och dess syfte?",
      "How does Thirukural address the theme of health and its importance?":
        "Hur tar Thirukkural upp hälsa och dess betydelse?",
      "What lessons does Thirukural offer on the balance between work and rest?":
        "Vilka lärdomar lär Thirukkural om balansen mellan arbete och fritid?",
      "Can you provide Thirukural's insights on the concept of duty and its relationship to morality?":
        "Kan du ge insiktsfulla insikter i begreppet plikt och dess förhållande till moral?",
      "What lessons does Thirukural offer on the importance of integrity and honesty?":
        "Vilka lärdomar lär Thirukkural om vikten av integritet och ärlighet?",
      "How does Thirukural address the theme of faith and its relationship to spirituality?":
        "Hur tar Thirukkural upp temat tro och dess förhållande till andlighet?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to faith?":
        "Vilka lärdomar lär Tirukkural om vikten av ödmjukhet och dess förhållande till tro?",
      "Can you provide Thirukural's insights on the concept of justice and its relationship to society?":
        "Kan du ge insiktsfulla insikter om rättvisa och dess relation till samhället?",
      "What lessons does Thirukural offer on the importance of compassion and its relationship to justice?":
        "Vilka lärdomar ger Thirukkural om vikten av medkänsla och dess förhållande till rättvisa?",
      "How does Thirukural address the theme of knowledge and its relationship to science and technology?":
        "Hur tar Thirukkural upp temat kunskap och dess relation till vetenskap och teknik?",
      "What lessons does Thirukural offer on the importance of humility and its relationship to knowledge?":
        "Vilka lärdomar lär Thirukkural om vikten av arbete och dess relation till kunskap?",
      "Can you provide Thirukural's insights on the concept of beauty and its relationship to art and creativity?":
        "Kan du ge Thirukkurals insikter i begreppet skönhet och dess relation till konst och kreativitet?",
      "What lessons does Thirukural offer on the importance of integrity and its relationship to art?":
        "Vilka lärdomar ger Thirukkural om vikten av integritet och dess förhållande till konst?",
    },
  };

  return translations[targetLanguage]?.[heading] ?? heading;
}
export function getAdhigaramTranslation(adhigaram, targetLanguage) {
  const translations = {
    telugu: {
      "Abstinence from flesh": "పంట వలన పరిమితి",
      "Against coveting another's wife": "ఇతరుల భార్యను కోరికించడం వ్యతిరేకంగా",
      "Against covetousness": "కోపాన్ని వ్యతిరేకంగా",
      "Against slander": "మీరుపెట్టు వ్యతిరేకంగా",
      "Against vain speaking": "వృథా మాట్లాడడం వ్యతిరేకంగా",
      "Apparising enemies": "శత్రువులను పరిచయం చేయడం",
      Asking: "వినడం",
      "Avoid envy": "ఇర్ష్యను నివారించండి",
      "Avoiding faults": "లోపాలను నివారించడం",
      "Avoiding mean company":
        "తక్కువ ప్రమాణాల కలిగిన వ్యక్తుల నుండి దూరంగా ఉండటం",
      "Avoiding terrorism": "అతిగా భయాందోళన నుండి దూరంగా ఉండటం",
      "Bad friendship": "చెడు స్నేహం",
      "Beauty extolled": "అందాన్ని పొగడడం",
      "Beauty's dart": "అందం యొక్క అస్త్రం",
      "Being led by women": "మహిళలచే నడిపించబడడం",
      "Benign looks": "శాంతమైన చూపులు",
      Bouderic: "బౌడెరిక్",
      Charity: "దానశీలత",
      "Cherishing kinsmen": "కుటుంబ సభ్యులను స్నేహపూర్వకంగా కాపడటం",
      "Chiding the heart": "హృదయాన్ని దురుసుగా పలకరించడం",
      Compassion: "కరుణ",
      "Courage before councils": "సభల ముందు ధైర్యం",
      Courtesy: "ఆతిథ్యసభ్యత",
      "Curbing of desire": "ఇష్టాన్ని అణచడం",
      "Decorum defied": "సభ్యతను ఉల్లంఘించడం",
      "Deliberation before action": "క్రియకు ముందు వివేచన",
      Destiny: "భవిష్యత్తు",
      "Divining the mind": "మనం యొక్క భావనను అంచనా వేయడం",
      "Dread of beggary": "భిక్షాధ్యర్థనకు భయం",
      "Dream visions": "కలల చూపులు",
      "Duty to society": "సమాజం పట్ల విధి",
      Education: "ఆశయం",
      "Embrace bliss": "ఆనందాన్ని ఆపిరించు",
      Energy: "శక్తి",
      Equity: "సమానత్వం",
      Espionage: "రహస్యవిషయాలు తెలుసుకోవడం",
      "Eventide sigh": "సాయంకాల వాపసు",
      "False friendship": "తప్పుడు స్నేహం",
      Farming: "వ్యవసాయం",
      "Fear of sin": "పాపం యొక్క భయం",
      "Feeling surmised": "భావనను అంచనా వేయడం",
      "Feigned anger": "తప్పుడు కోపం",
      Folly: "మూర్ఖత్వం",
      Forgiveness: "క్షమ",
      Fortress: "కోట",
      "Freedom from sloth": "జిల్లుగాలింపు నుండి విముక్తి",
      Friendship: "స్నేహం",
      "Futile wealth": "వృథా ధనం",
      "Gaining great men's help": "మహానుభావుల సహాయం పొందడం",
      Gambling: "జూదం",
      "Good decorum": "సామర్థ్యమైన నడవడిక",
      Gratitude: "కృతజ్ఞత",
      Greatness: "గౌరవం",
      Hatred: "శత్రుత",
      Honour: "మర్యాద",
      "Hope in mishap": "అనర్థంలో ఆశ",
      Hospitality: "అతిథి సేవ",
      Imposture: "మోసం",
      Instability: "అస్థిరత్వం",
      Intimacy: "స్నేహం",
      "Judging strength": "శక్తిని అంచనా వేయడం",
      "Judging the audience": "ప్రేక్షకులను అంచనా వేయడం",
      "Judging the place": "స్థలాన్ని అంచనా వేయడం",
      "Just government": "న్యాయ పరిపాలన",
      "Knowing proper time": "సరైన సమయాన్ని తెలుసుకోవడం",
      "Limbs languish": "అంగాలు అలసిపోవడం",
      Listening: "చెవిటి",
      "Longing for reunion": "పునరాగమానికి ఆశ",
      "Love's excellence": "ప్రేమ యొక్క ఉత్తమత",
      "Loving-kindness": "స్నేహపూర్వకత",
      "Manly effort": "పురుష సమర్థత",
      "Married Life": "పెళ్లి జీవితములు",
      Meanness: "కీచకత్వం",
      Medicine: "ఔషధం",
      "Military pride": "సైనిక గౌరవం",
      Ministers: "సచివులు",
      "Modes of action": "క్రియల మోడ్లు",
      "Mutual yearning": "పరస్పర ఆకాంక్ష",
      Nobility: "సౌజన్యం",
      "Noble hostility": "ఉత్తమ శత్రుత్వం",
      "Non-learning": "పాఠం నేర్చుకోవడం లేదు",
      "Non-killing": "హత్యకు వ్యతిరేకం",
      "Non-violence": "హింసకు వ్యతిరేకం",
      "Not drinking liquor": "మద్యం తాగడం లేదు",
      "Offend not the great": "మహానుభావులను కించపరచవద్దు",
      "Pangs of separation": "విఛిన్న బాధలు",
      Penance: "పణా",
      "Petty conceit": "సాధారణ అహంకారం",
      "Pining alone": "ఎక్కడ పడితే అక్కడ కాళ్ళు పడటం",
      Poverty: "పేదరికం",
      "Power of speech": "బాష శక్తి",
      "Powerful acts": "శక్తివంతమైన చర్యలు",
      "Promoting family welfare": "కుటుంబ సంక్షేమాన్ని ప్రోత్సహించడం",
      "Public clamour": "ప్రజా వినతి",
      "Purity of action": "చర్యల పవిత్రత",
      Renown: "ప్రసిద్ధి",
      Renunciation: "సంవరణ",
      "Reserve lost": "భద్రత కోల్పోయింది",
      "Restraining anger": "కోపాన్ని నిశ్చలపరచడం",
      "Sad memories": "దురదృష్టకరమైన జ్ఞాపకాలు",
      "Secret foe": "రహస్య శత్రువు",
      "Self-control": "స్వీయ నియంత్రణ",
      "Sensitiveness to shame": "లజ్జకు స్పందన",
      "Signs speak the heart": "చిహ్నాలు మనసును వ్యక్తం చేస్తాయి",
      Soliloquy: "తనతో మాట్లాడటం",
      Sublimity: "ప్రశంస",
      "Sulking charm": "ఉదాసీనమైన ఆకర్షణ",
      "Sweet words": "మధురమైన మాటలు",
      "Testing and entrusting": "పరీక్షించడం మరియు నమ్మకం",
      "Testing friendship": "స్నేహాన్ని పరీక్షించడం",
      "Testing of men for confidence":
        "స్వీయ నమ్మకం కోసం పురుషులను పరీక్షించడం",
      "The absence of fraud": "మోసపు లోపం",
      "The blessing of Rain": "వర్షం యొక్క ఆజ్ఞ",
      "The country": "దేశం",
      "The cruel tyranny": "కఠినమైన శాసన",
      "The embassy": "ప్రతినిధిత్వం",
      "The glory of army": "సైన్యపు గౌరవం",
      "The grandeur of monarchy": "రాజశ్రీ మహిమ",
      "The merit of Ascetics": "తపస్వుల గుణం",
      "The possession of knowledge": "జ్ఞానం యొక్క స్వాధీనం",
      "The power of virtue": "తత్వశక్తి",
      "The praise of God": "దైవ ప్రాశంస",
      "The wealth of children": "పిల్లల ధనం",
      "The worth of a wife": "భార్య యొక్క విలువ",
      "Truth consciousness": "సత్య సంబంధిత అవగాహన",
      Unforgetfulness: "మర్చిపోకపోవడం",
      Veracity: "సత్యత",
      "Wailing of pining love": "ప్రేమ యొక్క కలల వాపసు",
      "Wailing over pallor": "పలరాల యొక్క కలల వాపసు",
      "Walk with kings": "కింగ్స్ కి పాల్గాలు",
      "Wanton women": "కారాలాగారులు",
      "Wasteful look for wistful love": "కలల ప్రేమకు విస్మారులు",
      "Way of making wealth": "ధనం చేయడానికి మార్గం",
    },
    hindi: {
      "Abstinence from flesh": "मांस का परित्याग",
      "Against coveting another's wife": "दूसरों की पत्नी को इच्छाशक्ति न करना",
      "Against covetousness": "लोभ के खिलाफ",
      "Against slander": "निंदा के खिलाफ",
      "Against vain speaking": "व्यर्थ की बातों के खिलाफ",
      "Apparising enemies": "दुश्मनों की पहचान",
      Asking: "पूछना",
      "Avoid envy": "ईर्ष्या से बचें",
      "Avoiding faults": "दोषों से बचना",
      "Avoiding mean company": "नीच संगति से बचना",
      "Avoiding terrorism": "आतंकवाद से बचना",
      "Bad friendship": "बुरी मित्रता",
      "Beauty extolled": "सौंदर्य की प्रशंसा",
      "Beauty's dart": "सौंदर्य का बाण",
      "Being led by women": "अंगूठी देने वाली महिलाओं के कारण",
      "Benign looks": "दुःख न देने वाले दृष्टिकोण",
      Bouderic: "बुद्धिमत्ता",
      Charity: "दान",
      "Cherishing kinsmen": "कुटुंबियों का पोषण",
      "Chiding the heart": "हृदय को डांटना",
      Compassion: "दया",
      "Courage before councils": "परिषदों के सामने साहस",
      Courtesy: "शिष्टाचार",
      "Curbing of desire": "इच्छा को रोकना",
      "Decorum defied": "शिष्टाचार की अवहेलना",
      "Deliberation before action": "कार्य से पहले विचार",
      Destiny: "भाग्य",
      "Divining the mind": "मन की भविष्यवाणी",
      "Dread of beggary": "भिक्षावृत्ति का डर",
      "Dream visions": "सपनों की दृष्टि",
      "Duty to society": "समाज के प्रति कर्तव्य",
      Education: "शिक्षा",
      "Embrace bliss": "आनंद को गले लगाना",
      Energy: "ऊर्जा",
      Equity: "न्याय",
      Espionage: "जासूसी",
      "Eventide sigh": "सांझ की आह",
      "False friendship": "झूठी मित्रता",
      Farming: "कृषि",
      "Fear of sin": "पाप का डर",
      "Feeling surmised": "अनुमानित भावना",
      "Feigned anger": "झूठा गुस्सा",
      Folly: "मूर्खता",
      Forgiveness: "क्षमा",
      Fortress: "किला",
      "Freedom from sloth": "आलस्य से मुक्ति",
      Friendship: "मित्रता",
      "Futile wealth": "व्यर्थ धन",
      "Gaining great men's help": "महान पुरुषों की मदद प्राप्त करना",
      Gambling: "जुआ",
      "Good decorum": "अच्छा शिष्टाचार",
      Gratitude: "कृतज्ञता",
      Greatness: "महानता",
      Hatred: "घृणा",
      Honour: "सम्मान",
      "Hope in mishap": "दुर्घटना में आशा",
      Hospitality: "अतिथि सत्कार",
      Imposture: "छल",
      Instability: "अस्थिरता",
      Intimacy: "घनिष्ठता",
      "Judging strength": "शक्ति का न्याय",
      "Judging the audience": "दर्शकों का न्याय",
      "Judging the place": "स्थान का न्याय",
      "Just government": "न्यायपूर्ण सरकार",
      "Knowing proper time": "उचित समय जानना",
      "Limbs languish": "अंगों का दुर्बल होना",
      Listening: "सुनना",
      "Longing for reunion": "पुनर्मिलन की लालसा",
      "Love's excellence": "प्रेम की उत्कृष्टता",
      "Loving-kindness": "प्रेमपूर्ण दया",
      "Manly effort": "पुरुषार्थ",
      "Married Life": "विवाहित जीवन",
      Meanness: "नीचता",
      Medicine: "चिकित्सा",
      "Military pride": "सैन्य गर्व",
      Ministers: "मंत्री",
      "Modes of action": "कार्रवाई के तरीके",
      "Mutual yearning": "आपसी लालसा",
      Nobility: "श्रेष्ठता",
      "Noble hostility": "श्रेष्ठ शत्रुता",
      "Non- learning": "अज्ञान",
      "Non-killing": "अहिंसा",
      "Non-violence": "अहिंसा",
      "Not drinking liquor": "शराब न पीना",
      "Offend not the great": "महान को नाराज न करें",
      "Pangs of separation": "वियोग की पीड़ा",
      Penance: "प्रायश्चित",
      "Petty conceit": "छोटी घमंड",
      "Pining alone": "अकेले तड़पना",
      Poverty: "गरीबी",
      "Power of speech": "वाणी की शक्ति",
      "Powerful acts": "शक्तिशाली कार्य",
      "Promoting family welfare": "पारिवारिक कल्याण को बढ़ावा देना",
      "Public clamour": "सार्वजनिक शोर",
      "Purity of action": "कर्म की शुद्धता",
      Renown: "प्रसिद्धि",
      Renunciation: "त्याग",
      "Reserve lost": "आरक्षित खो गया",
      "Restraining anger": "क्रोध को रोकना",
      "Sad memories": "दुखद यादें",
      "Secret foe": "गुप्त शत्रु",
      "Self-control": "आत्म-नियंत्रण",
      "Sensitiveness to shame": "शर्म के प्रति संवेदनशीलता",
      "Signs speak the heart": "संकेत दिल की बात करते हैं",
      Soliloquy: "स्वगत भाषण",
      Sublimity: "उत्कृष्टता",
      "Sulking charm": "रूठने का आकर्षण",
      "Sweet words": "मधुर शब्द",
      "Testing and entrusting": "परीक्षण और विश्वास",
      "Testing friendship": "मित्रता का परीक्षण",
      "Testing of men for confidence": "आत्मविश्वास के लिए पुरुषों का परीक्षण",
      "The absence of fraud": "धोखाधड़ी की अनुपस्थिति",
      "The blessing of Rain": "वर्षा का आशीर्वाद",
      "The country": "देश",
      "The cruel tyranny": "क्रूर अत्याचार",
      "The embassy": "दूतावास",
      "The glory of army": "सेना की महिमा",
      "The grandeur of monarchy": "राजशाही की भव्यता",
      "The merit of Ascetics": "संन्यासियों का गुण",
      "The possession of knowledge": "ज्ञान का स्वामित्व",
      "The power of virtue": "सद्गुण की शक्ति",
      "The praise of God": "भगवान की स्तुति",
      "The wealth of children": "बच्चों की संपत्ति",
      "The worth of a wife": "पत्नी का मूल्य",
      "Truth consciousness": "सत्य चेतना",
      Unforgetfulness: "अविस्मरणीयता",
      Veracity: "सत्यता",
      "Wailing of pining love": "प्रेम की दुःख की गुस्सावानी",
      "Wailing over pallor": "पलर के बारे में गुस्सावानी",
      "Walk with kings": "शऐद के साथ चलना",
      "Wanton women": "बेचैन महिलाएं",
      "Wasteful look for wistful love": "दुःख के प्रेम के लिए विस्मारक दृष्टि",
      "Way of making wealth": "धन बनाने का रास्ता",
    },
    kannad: {
      "Abstinence from flesh": "ಮಾಂಸ ತ್ಯಾಗ",
      "Against coveting another's wife": "ಇತರರ ಹೆಂಡತಿಯನ್ನು ಬಯಸದಿರಿ",
      "Against covetousness": "ಲೋಭದ ವಿರುದ್ಧ",
      "Against slander": "ದೂಷಣೆಯ ವಿರುದ್ಧ",
      "Against vain speaking": "ನಿಷ್ಪ್ರಯೋಜಕ ಮಾತುಗಳ ವಿರುದ್ಧ",
      "Apparising enemies": "ಶತ್ರುಗಳನ್ನು ಗುರುತಿಸುವುದು",
      Asking: "ಕೇಳುವುದು",
      "Avoid envy": "ಹುಣೆಯನ್ನು ತಪ್ಪಿಸಿ",
      "Avoiding faults": "ದೋಷಗಳನ್ನು ತಪ್ಪಿಸುವುದು",
      "Avoiding mean company": "ಕೆಟ್ಟ ಸಂಗತಿಯನ್ನು ತಪ್ಪಿಸಿ",
      "Avoiding terrorism": "ಭಯೋತ್ಪಾದನೆಯನ್ನು ತಪ್ಪಿಸಿ",
      "Bad friendship": "ಕೆಟ್ಟ ಸ್ನೇಹ",
      "Beauty extolled": "ಸೌಂದರ್ಯದ ಪ್ರಶಂಸೆ",
      "Beauty's dart": "ಸೌಂದರ್ಯದ ಬಾಣ",
      "Being led by women": "ಮಹಿಳೆಯರಿಂದ ಮುನ್ನಡೆಸಲ್ಪಡುವುದು",
      "Benign looks": "ದಯಾಳು ನೋಟ",
      Bouderic: "ಬೌದ್ಧಿಕತೆ",
      Charity: "ದಾನ",
      "Cherishing kinsmen": "ಬಂಧುಗಳನ್ನು ಪೋಷಿಸುವುದು",
      "Chiding the heart": "ಹೃದಯವನ್ನು ಗದರಿಸುವುದು",
      Compassion: "ದಯೆ",
      "Courage before councils": "ಸಭೆಗಳ ಮುಂದೆ ಧೈರ್ಯ",
      Courtesy: "ವಿನಯ",
      "Curbing of desire": "ಆಸೆಗಳನ್ನು ನಿಯಂತ್ರಿಸುವುದು",
      "Decorum defied": "ಶಿಷ್ಟಾಚಾರದ ಉಲ್ಲಂಘನೆ",
      "Deliberation before action": "ಕ್ರಿಯೆಗೆ ಮುನ್ನ ಚಿಂತನೆ",
      Destiny: "ವಿಧಿ",
      "Divining the mind": "ಮನಸ್ಸಿನ ಭವಿಷ್ಯವಾಣಿ",
      "Dread of beggary": "ಭಿಕ್ಷಾಟನೆಯ ಭಯ",
      "Dream visions": "ಕನಸುಗಳ ದೃಷ್ಟಿ",
      "Duty to society": "ಸಮಾಜದತ್ತ ಕರ್ತವ್ಯ",
      Education: "ಶಿಕ್ಷಣ",
      "Embrace bliss": "ಆನಂದವನ್ನು ಅಪ್ಪಿಕೊಳ್ಳಿ",
      Energy: "ಶಕ್ತಿ",
      Equity: "ನ್ಯಾಯ",
      Espionage: "ಗೂಢಚರ್ಯೆ",
      "Eventide sigh": "ಸಂಜೆಯ ನಿಟ್ಟುಸಿರು",
      "False friendship": "ಸುಳ್ಳು ಸ್ನೇಹ",
      Farming: "ಕೃಷಿ",
      "Fear of sin": "ಪಾಪದ ಭಯ",
      "Feeling surmised": "ಅನುಮಾನಿತ ಭಾವನೆ",
      "Feigned anger": "ಕಪಟ ಕೋಪ",
      Folly: "ಮೂರ್ಖತನ",
      Forgiveness: "ಕ್ಷಮೆ",
      Fortress: "ಕೋಟೆ",
      "Freedom from sloth": "ಆಲಸ್ಯದಿಂದ ಮುಕ್ತಿ",
      Friendship: "ಸ್ನೇಹ",
      "Futile wealth": "ನಿಷ್ಪ್ರಯೋಜಕ ಸಂಪತ್ತು",
      "Gaining great men's help": "ಮಹಾನ್ ಪುರುಷರ ಸಹಾಯವನ್ನು ಪಡೆಯುವುದು",
      Gambling: "ಜೂಜಾಟ",
      "Good decorum": "ಉತ್ತಮ ಶಿಷ್ಟಾಚಾರ",
      Gratitude: "ಕೃತಜ್ಞತೆ",
      Greatness: "ಮಹತ್ವ",
      Hatred: "ದ್ವೇಷ",
      Honour: "ಗೌರವ",
      "Hope in mishap": "ಅಪಘಾತದಲ್ಲಿ ಆಶೆ",
      Hospitality: "ಅತಿಥಿ ಸತ್ಕಾರ",
      Imposture: "ವಂಚನೆ",
      Instability: "ಅಸ್ಥಿರತೆ",
      Intimacy: "ಆತ್ಮೀಯತೆ",
      "Judging strength": "ಶಕ್ತಿಯನ್ನು ಮೌಲ್ಯಮಾಪನ",
      "Judging the audience": "ಪ್ರೇಕ್ಷಕರನ್ನು ಮೌಲ್ಯಮಾಪನ",
      "Judging the place": "ಸ್ಥಳವನ್ನು ಮೌಲ್ಯಮಾಪನ",
      "Just government": "ನ್ಯಾಯಸಮ್ಮತ ಸರ್ಕಾರ",
      "Knowing proper time": "ಸರಿಯಾದ ಸಮಯವನ್ನು ತಿಳಿದುಕೊಳ್ಳುವುದು",
      "Limbs languish": "ಅಂಗಗಳು ದುರ್ಬಲವಾಗುತ್ತವೆ",
      Listening: "ಕೆಳವುದು",
      "Longing for reunion": "ಮರುಮಿಲನದ ಆಸೆ",
      "Love's excellence": "ಪ್ರೇಮದ ಶ್ರೇಷ್ಠತೆ",
      "Loving-kindness": "ಪ್ರೇಮಪೂರ್ಣ ದಯೆ",
      "Manly effort": "ಪುರುಷಾರ್ಥ",
      "Married Life": "ವಿವಾಹಿತ ಜೀವನ",
      Meanness: "ಹೀನತೆ",
      Medicine: "ಔಷಧಿ",
      "Military pride": "ಸೈನಿಕ ಹೆಮ್ಮೆ",
      Ministers: "ಮಂತ್ರಿಗಳು",
      "Modes of action": "ಕ್ರಿಯೆಗಳ ವಿಧಾನಗಳು",
      "Mutual yearning": "ಪರಸ್ಪರ ಆಸೆ",
      Nobility: "ಉನ್ನತತೆ",
      "Noble hostility": "ಉನ್ನತ ಶತ್ರುತೆ",
      "Non- learning": "ಅಜ್ಞಾನ",
      "Non-killing": "ಹತ್ಯೆ ಮಾಡದಿರುವುದು",
      "Non-violence": "ಅಹಿಂಸೆ",
      "Not drinking liquor": "ಮದ್ಯಪಾನ ಮಾಡದಿರುವುದು",
      "Offend not the great": "ಮಹಾನ್ ವ್ಯಕ್ತಿಗಳನ್ನು ಅಪಮಾನಿಸಬೇಡಿ",
      "Pangs of separation": "ವಿಯೋಗದ ನೋವು",
      Penance: "ಪ್ರಾಯಶ್ಚಿತ್ತ",
      "Petty conceit": "ಸಣ್ಣ ಅಹಂಕಾರ",
      "Pining alone": "ಒಂಟಿಯಾಗಿ ತವಕಿಸುತ್ತಿರುವುದು",
      Poverty: "ಬಡತನ",
      "Power of speech": "ಮಾತಿನ ಶಕ್ತಿ",
      "Powerful acts": "ಶಕ್ತಿಶಾಲಿ ಕೃತ್ಯಗಳು",
      "Promoting family welfare": "ಕುಟುಂಬದ ಕಲ್ಯಾಣವನ್ನು ಉತ್ತೇಜಿಸುವುದು",
      "Public clamour": "ಸಾರ್ವಜನಿಕ ಗದ್ದಲ",
      "Purity of action": "ಕೃತ್ಯದ ಶುದ್ಧತೆ",
      Renown: "ಪ್ರಸಿದ್ಧಿ",
      Renunciation: "ತ್ಯಾಗ",
      "Reserve lost": "ಸಂರಕ್ಷಣೆ ಕಳೆದುಹೋಗಿದೆ",
      "Restraining anger": "ಕೋಪವನ್ನು ನಿಯಂತ್ರಿಸುವುದು",
      "Sad memories": "ದುಃಖದ ನೆನಪುಗಳು",
      "Secret foe": "ರಹಸ್ಯ ಶತ್ರು",
      "Self-control": "ಸ್ವಯಂ ನಿಯಂತ್ರಣ",
      "Sensitiveness to shame": "ನಾಚಿಕೆಗೆ ಸಂವೇದನೆ",
      "Signs speak the heart": "ಗುರುತುಗಳು ಹೃದಯವನ್ನು ವ್ಯಕ್ತಪಡಿಸುತ್ತವೆ",
      Soliloquy: "ಸ್ವಗತ",
      Sublimity: "ಉನ್ನತತೆ",
      "Sulking charm": "ಮಂಕಾದ ಆಕರ್ಷಣೆ",
      "Sweet words": "ಮಧುರ ಮಾತುಗಳು",
      "Testing and entrusting": "ಪರೀಕ್ಷೆ ಮತ್ತು ನಂಬಿಕೆ",
      "Testing friendship": "ಸ್ನೇಹವನ್ನು ಪರೀಕ್ಷಿಸುವುದು",
      "Testing of men for confidence":
        "ಆತ್ಮವಿಶ್ವಾಸಕ್ಕಾಗಿ ಪುರುಷರನ್ನು ಪರೀಕ್ಷಿಸುವುದು",
      "The absence of fraud": "ವಂಚನೆಯ ಅನುಪಸ್ಥಿತಿ",
      "The blessing of Rain": "ಮಳೆಯ ಆಶೀರ್ವಾದ",
      "The country": "ದೇಶ",
      "The cruel tyranny": "ಕ್ರೂರ ಶಾಸನ",
      "The embassy": "ರಾಯಭಾರಿ",
      "The glory of army": "ಸೈನ್ಯದ ಮಹಿಮೆ",
      "The grandeur of monarchy": "ರಾಜಶಾಹಿಯ ಭವ್ಯತೆ",
      "The merit of Ascetics": "ತಪಸ್ವಿಗಳ ಗುಣ",
      "The possession of knowledge": "ಜ್ಞಾನದ ಸ್ವಾಧೀನ",
      "The power of virtue": "ಧರ್ಮದ ಶಕ್ತಿ",
      "The praise of God": "ದೇವರ ಸ್ತುತಿ",
      "The wealth of children": "ಮಕ್ಕಳ ಸಂಪತ್ತು",
      "The worth of a wife": "ಹೆಂಡತಿಯ ಮೌಲ್ಯ",
      "Truth consciousness": "ಸತ್ಯದ ಅರಿವು",
      Unforgetfulness: "ಮರೆತಿರದಿರುವುದು",
      Veracity: "ಸತ್ಯತೆ",
      "Wailing of pining love": "ಪ್ರೇಮದ ದುಃಖದ ಗುಸ್ಸಾವಾನಿ",
      "Wailing over pallor": "ಪಲರ ಬಗ್ಗೆ ಗುಸ್ಸಾವಾನಿ",
      "Walk with kings": "ಶऐದ ಕೇಳಿರಿ",
      "Wanton women": "ಬೆಚೆನ ಮಹಿಳಾರು",
      "Wasteful look for wistful love": "ದುಃಖ ಕೇ ಪ್ರೇಮದ ಲಿಕ್ಕಾಗಿ ವಿಸ್ಮಾರಕ ನೋಟ",
      "Way of making wealth": "ಧನ ಬನಾಟಿಸುವ ರಾಸ್ತೆ",
    },
    french: {
      "Abstinence from flesh": "Abstinence de la chair",
      "Against coveting another's wife":
        "Contre le désir de la femme d'un autre",
      "Against covetousness": "Contre la convoitise",
      "Against slander": "Contre la calomnie",
      "Against vain speaking": "Contre les paroles vaines",
      "Apparising enemies": "Identifier les ennemis",
      Asking: "Demander",
      "Avoid envy": "Éviter l'envie",
      "Avoiding faults": "Éviter les fautes",
      "Avoiding mean company": "Éviter la mauvaise compagnie",
      "Avoiding terrorism": "Éviter le terrorisme",
      "Bad friendship": "Mauvaise amitié",
      "Beauty extolled": "Beauté exaltée",
      "Beauty's dart": "Flèche de la beauté",
      "Being led by women": "Être dirigé par des femmes",
      "Benign looks": "Regards bienveillants",
      Bouderic: "Intelligence",
      Charity: "Charité",
      "Cherishing kinsmen": "Chérir les proches",
      "Chiding the heart": "Réprimander le cœur",
      Compassion: "Compassion",
      "Courage before councils": "Courage devant les conseils",
      Courtesy: "Courtoisie",
      "Curbing of desire": "Réprimer le désir",
      "Decorum defied": "Décorum défié",
      "Deliberation before action": "Délibération avant l'action",
      Destiny: "Destin",
      "Divining the mind": "Deviner l'esprit",
      "Dread of beggary": "Peur de la mendicité",
      "Dream visions": "Visions de rêve",
      "Duty to society": "Devoir envers la société",
      Education: "Éducation",
      "Embrace bliss": "Embrasser le bonheur",
      Energy: "Énergie",
      Equity: "Équité",
      Espionage: "Espionnage",
      "Eventide sigh": "Soupir du soir",
      "False friendship": "Fausse amitié",
      Farming: "Agriculture",
      "Fear of sin": "Peur du péché",
      "Feeling surmised": "Sentiment supposé",
      "Feigned anger": "Colère feinte",
      Folly: "Folie",
      Forgiveness: "Pardon",
      Fortress: "Forteresse",
      "Freedom from sloth": "Liberté de la paresse",
      Friendship: "Amitié",
      "Futile wealth": "Richesse futile",
      "Gaining great men's help": "Obtenir l'aide des grands hommes",
      Gambling: "Jeu",
      "Good decorum": "Bon décorum",
      Gratitude: "Gratitude",
      Greatness: "Grandeur",
      Hatred: "Haine",
      Honour: "Honneur",
      "Hope in mishap": "Espoir dans le malheur",
      Hospitality: "Hospitalité",
      Imposture: "Imposture",
      Instability: "Instabilité",
      Intimacy: "Intimité",
      "Judging strength": "Jugement de la force",
      "Judging the audience": "Jugement du public",
      "Judging the place": "Jugement du lieu",
      "Just government": "Gouvernement juste",
      "Knowing proper time": "Connaître le bon moment",
      "Limbs languish": "Les membres languissent",
      Listening: "Écouter",
      "Longing for reunion": "Désir de réunion",
      "Love's excellence": "Excellence de l'amour",
      "Loving-kindness": "Bonté aimante",
      "Manly effort": "Effort viril",
      "Married Life": "Vie maritale",
      Meanness: "Méchanceté",
      Medicine: "Médecine",
      "Military pride": "Fierté militaire",
      Ministers: "Ministres",
      "Modes of action": "Modes d'action",
      "Mutual yearning": "Désir mutuel",
      Nobility: "Noblesse",
      "Noble hostility": "Hostilité noble",
      "Non- learning": "Non-apprentissage",
      "Non-killing": "Non-meurtre",
      "Non-violence": "Non-violence",
      "Not drinking liquor": "Ne pas boire d'alcool",
      "Offend not the great": "Ne pas offenser les grands",
      "Pangs of separation": "Douleurs de la séparation",
      Penance: "Pénitence",
      "Petty conceit": "Petite vanité",
      "Pining alone": "Langueur solitaire",
      Poverty: "Pauvreté",
      "Power of speech": "Pouvoir de la parole",
      "Powerful acts": "Actes puissants",
      "Promoting family welfare": "Promouvoir le bien-être familial",
      "Public clamour": "Clameur publique",
      "Purity of action": "Pureté de l'action",
      Renown: "Renommée",
      Renunciation: "Renonciation",
      "Reserve lost": "Réserve perdue",
      "Restraining anger": "Réprimer la colère",
      "Sad memories": "Souvenirs tristes",
      "Secret foe": "Ennemi secret",
      "Self-control": "Maîtrise de soi",
      "Sensitiveness to shame": "Sensibilité à la honte",
      "Signs speak the heart": "Les signes parlent du cœur",
      Soliloquy: "Soliloque",
      Sublimity: "Sublimité",
      "Sulking charm": "Charme boudeur",
      "Sweet words": "Mots doux",
      "Testing and entrusting": "Tester et confier",
      "Testing friendship": "Tester l'amitié",
      "Testing of men for confidence": "Tester les hommes pour la confiance",
      "The absence of fraud": "L'absence de fraude",
      "The blessing of Rain": "La bénédiction de la pluie",
      "The country": "Le pays",
      "The cruel tyranny": "La tyrannie cruelle",
      "The embassy": "L'ambassade",
      "The glory of army": "La gloire de l'armée",
      "The grandeur of monarchy": "La grandeur de la monarchie",
      "The merit of Ascetics": "Le mérite des ascètes",
      "The possession of knowledge": "La possession de la connaissance",
      "The power of virtue": "Le pouvoir de la vertu",
      "The praise of God": "La louange de Dieu",
      "The wealth of children": "La richesse des enfants",
      "The worth of a wife": "La valeur d'une femme",
      "Truth consciousness": "Conscience de la vérité",
      Unforgetfulness: "Inoubli",
      Veracity: "Véracité",
      "Wailing of pining love": "Lamentation d'un amour languissant",
      "Wailing over pallor": "Lamentation sur la pâleur",
      "Walk with kings": "Marcher avec les rois",
      "Wanton women": "Femmes frivoles",
      "Wasteful look for wistful love":
        "Regard vain pour un amour mélancolique",
      "Way of making wealth": "Façon de faire fortune",
    },
    arabic: {
      "Abstinence from flesh": "امتناع عن اللحم",
      "Against coveting another's wife": "ضد رغبة زوجة آخر",
      "Against covetousness": "ضد الطمع",
      "Against slander": "ضد القذف",
      "Against vain speaking": "ضد الكلام الفارغ",
      "Apparising enemies": "معرفة الأعداء",
      Asking: "الطلب",
      "Avoid envy": "تجنب الحسد",
      "Avoiding faults": "تجنب العيوب",
      "Avoiding mean company": "تجنب الشركة السيئة",
      "Avoiding terrorism": "تجنب الإرهاب",
      "Bad friendship": "الصديق السيئ",
      "Beauty extolled": "مدح الجمال",
      "Beauty's dart": "سهم الجمال",
      "Being led by women": "القيادة من قبل النساء",
      "Benign looks": "النظرات الطيبة",
      Bouderic: "الذكاء",
      Charity: "الصدقة",
      "Cherishing kinsmen": "تربية الأقارب",
      "Chiding the heart": "تأديب القلب",
      Compassion: "الرحمة",
      "Courage before councils": "الشجاعة أمام المجالس",
      Courtesy: "الأدب",
      "Curbing of desire": "كبح الرغبة",
      "Decorum defied": "تجاهل الأدب",
      "Deliberation before action": "التفكير قبل العمل",
      Destiny: "القضاء",
      "Divining the mind": "تخمين العقل",
      "Dread of beggary": "خوف الفقر",
      "Dream visions": "رؤى الأحلام",
      "Duty to society": "الواجب تجاه المجتمع",
      Education: "التعليم",
      "Embrace bliss": "استقبال السعادة",
      Energy: "الطاقة",
      Equity: "العدالة",
      Espionage: "الجاسوسية",
      "Eventide sigh": "تنهيدة المساء",
      "False friendship": "الصديق الكاذب",
      Farming: "الزراعة",
      "Fear of sin": "خوف من الخطيئة",
      "Feeling surmised": "الشعور بالشك",
      "Feigned anger": "الغضب المزيف",
      Folly: "الجهل",
      Forgiveness: "الغفران",
      Fortress: "الحصن",
      "Freedom from sloth": "الحرية من الكسل",
      Friendship: "الصديقة",
      "Futile wealth": "الثروة الباطلة",
      "Gaining great men's help": "الحصول على مساعدة الرجال الكبار",
      Gambling: "القمار",
      "Good decorum": "الأدب الجيد",
      Gratitude: "الشكر",
      Greatness: "العظمة",
      Hatred: "الكراهية",
      Honour: "الشرف",
      "Hope in mishap": "الأمل في المصيبة",
      Hospitality: "الضيافة",
      Imposture: "النفاق",
      Instability: "العدم الاستقرار",
      Intimacy: "الود",
      "Judging strength": "تقييم القوة",
      "Judging the audience": "تقييم الجمهور",
      "Judging the place": "تقييم المكان",
      "Just government": "الحكومة العادلة",
      "Knowing proper time": "معرفة الوقت المناسب",
      "Limbs languish": "تضمحل الأعضاء",
      Listening: "الاستماع",
      "Longing for reunion": "الرغبة في اللقاء",
      "Love's excellence": "فضيلة الحب",
      "Loving-kindness": "الرحمة",
      "Manly effort": "الجهد الرجولي",
      "Married Life": "الحياة الزوجية",
      Meanness: "الدناءة",
      Medicine: "الطب",
      "Military pride": "الفخر العسكري",
      Ministers: "الوزراء",
      "Modes of action": "أشكال العمل",
      "Mutual yearning": "الرغبة المتبادلة",
      Nobility: "النبل",
      "Noble hostility": "العداوة النبيلة",
      "Non- learning": "عدم التعلم",
      "Non-killing": "عدم القتل",
      "Non-violence": "عدم العنف",
      "Not drinking liquor": "عدم شرب الخمر",
      "Offend not the great": "لا تؤذي الكبار",
      "Pangs of separation": "ألم الفراق",
      Penance: "التوبة",
      "Petty conceit": "الغرور الصغير",
      "Pining alone": "المرض الوحيد",
      Poverty: "الفقر",
      "Power of speech": "قوة الكلام",
      "Powerful acts": "أعمال قوية",
      "Promoting family welfare": "تعزيز رفاهية الأسرة",
      "Public clamour": "الضجة العامة",
      "Purity of action": "نقاوة العمل",
      Renown: "الشهرة",
      Renunciation: "التنازل",
      "Reserve lost": "الاحتياط المفقود",
      "Restraining anger": "كبح الغضب",
      "Sad memories": "ذكريات حزينة",
      "Secret foe": "عدو سري",
      "Self-control": "سيطرة النفس",
      "Sensitiveness to shame": "الحساسية للعار",
      "Signs speak the heart": "العلامات تتكلم عن القلب",
      Soliloquy: "المناجاة",
      Sublimity: "السمو",
      "Sulking charm": "الجاذبية المترنحة",
      "Sweet words": "الكلمات الحلوة",
      "Testing and entrusting": "الاختبار والتوكل",
      "Testing friendship": "اختبار الصداقة",
      "Testing of men for confidence": "اختبار الرجال للاستقامة",
      "The absence of fraud": "غياب الغش",
      "The blessing of Rain": "بركة المطر",
      "The country": "البلد",
      "The cruel tyranny": "الاستبداد القاسي",
      "The embassy": "السفارة",
      "The glory of army": "مجدا الجيش",
      "The grandeur of monarchy": "عظمة الملكية",
      "The merit of Ascetics": "فضيلة الزهاد",
      "The possession of knowledge": "امتلاك المعرفة",
      "The power of virtue": "قوة الفضيلة",
      "The praise of God": "مدح الله",
      "The wealth of children": "ثروة الأطفال",
      "The worth of a wife": "قيمة الزوجة",
      "Truth consciousness": "وعي الحقيقة",
      Unforgetfulness: "عدم النسيان",
      Veracity: "الصدق",
      "Wailing of pining love": "نواح الحب المشتاق",
      "Wailing over pallor": "النواح على الشحوب",
      "Walk with kings": "المشي مع الملوك",
      "Wanton women": "النساء الفاجرات",
      "Wasteful look for wistful love": "نظرة مهدرة للحب الحزين",
      "Way of making wealth": "طريقة صنع الثروة",
    },
    chinese: {
      "Abstinence from flesh": "戒肉",
      "Against coveting another's wife": "反对觊觎他人妻",
      "Against covetousness": "反对贪婪",
      "Against slander": "反对诽谤",
      "Against vain speaking": "反对空谈",
      "Apparising enemies": "识别敌人",
      Asking: "询问",
      "Avoid envy": "避免嫉妒",
      "Avoiding faults": "避免过失",
      "Avoiding mean company": "避免恶友",
      "Avoiding terrorism": "避免恐怖主义",
      "Bad friendship": "恶友",
      "Beauty extolled": "美之赞美",
      "Beauty's dart": "美的箭矢",
      "Being led by women": "被女性引导",
      "Benign looks": "和善的眼神",
      Bouderic: "不悦",
      Charity: "慈善",
      "Cherishing kinsmen": "珍爱亲人",
      "Chiding the heart": "责备心",
      Compassion: "慈悲",
      "Courage before councils": "议会前的勇气",
      Courtesy: "礼貌",
      "Curbing of desire": "抑制欲望",
      "Decorum defied": "无礼",
      "Deliberation before action": "行动前的考虑",
      Destiny: "命运",
      "Divining the mind": "占卜心灵",
      "Dread of beggary": "惧怕乞讨",
      "Dream visions": "梦境",
      "Duty to society": "对社会的责任",
      Education: "教育",
      "Embrace bliss": "拥抱幸福",
      Energy: "能量",
      Equity: "公平",
      Espionage: "间谍",
      "Eventide sigh": "黄昏的叹息",
      "False friendship": "假友情",
      Farming: "农耕",
      "Fear of sin": "惧怕罪恶",
      "Feeling surmised": "感觉被推测",
      "Feigned anger": "假装愤怒",
      Folly: "愚蠢",
      Forgiveness: "宽恕",
      Fortress: "堡垒",
      "Freedom from sloth": "免于懒惰",
      Friendship: "友谊",
      "Futile wealth": "无用的财富",
      "Gaining great men's help": "获得伟人的帮助",
      Gambling: "赌博",
      "Good decorum": "良好的礼仪",
      Gratitude: "感激",
      Greatness: "伟大",
      Hatred: "憎恨",
      Honour: "荣誉",
      "Hope in mishap": "厄运中的希望",
      Hospitality: "好客",
      Imposture: "冒充",
      Instability: "不稳定",
      Intimacy: "亲密",
      "Judging strength": "评判力量",
      "Judging the audience": "评判观众",
      "Judging the place": "评判地点",
      "Just government": "公正的政府",
      "Knowing proper time": "知晓适当时机",
      "Limbs languish": "肢体衰弱",
      Listening: "倾听",
      "Longing for reunion": "渴望团聚",
      "Love's excellence": "爱的卓越",
      "Loving-kindness": "慈悲",
      "Manly effort": "男子汉的努力",
      "Married Life": "婚姻生活",
      Meanness: "卑鄙",
      Medicine: "医学",
      "Military pride": "军人的自豪",
      Ministers: "部长",
      "Modes of action": "行动方式",
      "Mutual yearning": "相互渴望",
      Nobility: "高贵",
      "Noble hostility": "高贵的敌意",
      "Non- learning": "不学习",
      "Non-killing": "不杀戮",
      "Non-violence": "非暴力",
      "Not drinking liquor": "不饮酒",
      "Offend not the great": "不得罪伟人",
      "Pangs of separation": "分离的痛苦",
      Penance: "苦修",
      "Petty conceit": "小小的自负",
      "Pining alone": "独自悲伤",
      Poverty: "贫穷",
      "Power of speech": "言辞的力量",
      "Powerful acts": "强大的行动",
      "Promoting family welfare": "促进家庭福利",
      "Public clamour": "公众的喧哗",
      "Purity of action": "行动的纯洁",
      Renown: "声誉",
      Renunciation: "放弃",
      "Reserve lost": "失去保留",
      "Restraining anger": "抑制愤怒",
      "Sad memories": "悲伤的回忆",
      "Secret foe": "隐秘的敌人",
      "Self-control": "自我控制",
      "Sensitiveness to shame": "对羞耻的敏感",
      "Signs speak the heart": "迹象表达心灵",
      Soliloquy: "独白",
      Sublimity: "崇高",
      "Sulking charm": "生气的魅力",
      "Sweet words": "甜蜜的话语",
      "Testing and entrusting": "测试和委托",
      "Testing friendship": "测试友谊",
      "Testing of men for confidence": "测试人们的信心",
      "The absence of fraud": "欺诈的缺席",
      "The blessing of Rain": "雨的祝福",
      "The country": "国家",
      "The cruel tyranny": "残酷的暴政",
      "The embassy": "大使馆",
      "The glory of army": "军队的荣耀",
      "The grandeur of monarchy": "君主的宏伟",
      "The merit of Ascetics": "苦行者的美德",
      "The possession of knowledge": "知识的拥有",
      "The power of virtue": "美德的力量",
      "The praise of God": "对上帝的赞美",
      "The wealth of children": "孩子们的财富",
      "The worth of a wife": "妻子的价值",
      "Truth consciousness": "真理意识",
      Unforgetfulness: "不忘",
      Veracity: "真实",
      "Wailing of pining love": "相思之苦的哀叹",
      "Wailing over pallor": "苍白之上的哀叹",
      "Walk with kings": "与国王同行",
      "Wanton women": "放荡的女人",
      "Wasteful look for wistful love": "为哀伤的爱情而浪费的目光",
      "Way of making wealth": "致富之道",
    },
    german: {
      "Abstinence from flesh": "Fleischabstinenz",
      "Against coveting another's wife":
        "Gegen das Begehren der Frau eines anderen",
      "Against covetousness": "Gegen die Habsucht",
      "Against slander": "Gegen Verleumdung",
      "Against vain speaking": "Gegen das leere Sprechen",
      "Apparising enemies": "Feinde erkennen",
      Asking: "Fragen",
      "Avoid envy": "Vermeide Neid",
      "Avoiding faults": "Vermeide Fehler",
      "Avoiding mean company": "Vermeide schlechte Gesellschaft",
      "Avoiding terrorism": "Vermeide Terrorismus",
      "Bad friendship": "Schlechte Freundschaft",
      "Beauty extolled": "Schönheit gepriesen",
      "Beauty's dart": "Schönheitspfeil",
      "Being led by women": "Von Frauen geführt werden",
      "Benign looks": "Gütige Blicke",
      Bouderic: "Intelligenz",
      Charity: "Wohltätigkeit",
      "Cherishing kinsmen": "Verwandte pflegen",
      "Chiding the heart": "Das Herz zurechtweisen",
      Compassion: "Mitgefühl",
      "Courage before councils": "Mut vor Räten",
      Courtesy: "Höflichkeit",
      "Curbing of desire": "Zügelung des Verlangens",
      "Decorum defied": "Anstand getrotzt",
      "Deliberation before action": "Überlegung vor der Handlung",
      Destiny: "Schicksal",
      "Divining the mind": "Das Denken erahnen",
      "Dread of beggary": "Furcht vor Betteln",
      "Dream visions": "Traumvisionen",
      "Duty to society": "Pflicht gegenüber der Gesellschaft",
      Education: "Bildung",
      "Embrace bliss": "Glück umarmen",
      Energy: "Energie",
      Equity: "Gerechtigkeit",
      Espionage: "Spionage",
      "Eventide sigh": "Abendseufzer",
      "False friendship": "Falsche Freundschaft",
      Farming: "Landwirtschaft",
      "Fear of sin": "Furcht vor Sünde",
      "Feeling surmised": "Gefühl vermutet",
      "Feigned anger": "Vorgetäuschter Zorn",
      Folly: "Torheit",
      Forgiveness: "Vergebung",
      Fortress: "Festung",
      "Freedom from sloth": "Freiheit von Trägheit",
      Friendship: "Freundschaft",
      "Futile wealth": "Nutzloses Vermögen",
      "Gaining great men's help": "Gewinnung der Hilfe großer Männer",
      Gambling: "Glücksspiel",
      "Good decorum": "Gutes Anstandsgefühl",
      Gratitude: "Dankbarkeit",
      Greatness: "Größe",
      Hatred: "Hass",
      Honour: "Ehre",
      "Hope in mishap": "Hoffnung in Unglück",
      Hospitality: "Gastfreundschaft",
      Imposture: "Täuschung",
      Instability: "Instabilität",
      Intimacy: "Intimität",
      "Judging strength": "Stärke beurteilen",
      "Judging the audience": "Das Publikum beurteilen",
      "Judging the place": "Den Ort beurteilen",
      "Just government": "Gerechte Regierung",
      "Knowing proper time": "Die richtige Zeit kennen",
      "Limbs languish": "Gliedmaßen ermatten",
      Listening: "Zuhören",
      "Longing for reunion": "Sehnsucht nach Wiedervereinigung",
      "Love's excellence": "Die Exzellenz der Liebe",
      "Loving-kindness": "Liebevolle Güte",
      "Manly effort": "Männliche Anstrengung",
      "Married Life": "Eheleben",
      Meanness: "Gemeinheit",
      Medicine: "Medizin",
      "Military pride": "Militärstolz",
      Ministers: "Minister",
      "Modes of action": "Handlungsweisen",
      "Mutual yearning": "Gegenseitiges Verlangen",
      Nobility: "Adel",
      "Noble hostility": "Edle Feindseligkeit",
      "Non- learning": "Nicht-Lernen",
      "Non-killing": "Nicht-Töten",
      "Non-violence": "Nicht-Gewalt",
      "Not drinking liquor": "Kein Alkohol trinken",
      "Offend not the great": "Den Großen nicht beleidigen",
      "Pangs of separation": "Schmerzen der Trennung",
      Penance: "Buße",
      "Petty conceit": "Kleine Eitelkeit",
      "Pining alone": "Allein Sehnsucht haben",
      Poverty: "Armut",
      "Power of speech": "Die Kraft der Sprache",
      "Powerful acts": "Mächtige Taten",
      "Promoting family welfare": "Förderung des Familienwohls",
      "Public clamour": "Öffentlicher Lärm",
      "Purity of action": "Reinheit der Handlung",
      Renown: "Ruhm",
      Renunciation: "Verzicht",
      "Reserve lost": "Reserve verloren",
      "Restraining anger": "Zorn zurückhalten",
      "Sad memories": "Traurige Erinnerungen",
      "Secret foe": "Heimlicher Feind",
      "Self-control": "Selbstkontrolle",
      "Sensitiveness to shame": "Empfindlichkeit gegenüber Scham",
      "Signs speak the heart": "Zeichen sprechen das Herz",
      Soliloquy: "Monolog",
      Sublimity: "Erhabenheit",
      "Sulking charm": "Murrender Charme",
      "Sweet words": "Süße Worte",
      "Testing and entrusting": "Testen und anvertrauen",
      "Testing friendship": "Freundschaft testen",
      "Testing of men for confidence": "Testen von Männern für Vertrauen",
      "The absence of fraud": "Das Fehlen von Betrug",
      "The blessing of Rain": "Der Segen des Regens",
      "The country": "Das Land",
      "The cruel tyranny": "Die grausame Tyrannei",
      "The embassy": "Die Botschaft",
      "The glory of army": "Der Ruhm der Armee",
      "The grandeur of monarchy": "Die Pracht der Monarchie",
      "The merit of Ascetics": "Das Verdienst der Asketen",
      "The possession of knowledge": "Der Besitz von Wissen",
      "The power of virtue": "Die Kraft der Tugend",
      "The praise of God": "Das Lob Gottes",
      "The wealth of children": "Der Reichtum der Kinder",
      "The worth of a wife": "Der Wert einer Frau",
      "Truth consciousness": "Wahrheitsbewusstsein",
      Unforgetfulness: "Unvergesslichkeit",
      Veracity: "Wahrhaftigkeit",
      "Wailing of pining love": "Liebeswehen des Verlangens",
      "Wailing over pallor": "Gelbsucht über Gelb",
      "Walk with kings": "Gehe mit Königen um",
      "Wanton women": "Böse Frauen",
      "Wasteful look for wistful love": "Vergebliche Lektüre für trübe Liebe",
      "Way of making wealth": "Weg zum Reichtum",
    },
    korean: {
      "Abstinence from flesh": "고기 금욕",
      "Against coveting another's wife": "타인의 아내를 탐내는 것에 대하여",
      "Against covetousness": "탐욕에 대하여",
      "Against slander": "모함에 대하여",
      "Against vain speaking": "헛된 말에 대하여",
      "Apparising enemies": "적을 식별하는 것",
      Asking: "묻는 것",
      "Avoid envy": "시기하지 말라",
      "Avoiding faults": "잘못을 피하는 것",
      "Avoiding mean company": "나쁜 동료를 피하는 것",
      "Avoiding terrorism": "테러를 피하는 것",
      "Bad friendship": "나쁜 우정",
      "Beauty extolled": "미의 찬양",
      "Beauty's dart": "미의 화살",
      "Being led by women": "여성에 의해 이끌리는 것",
      "Benign looks": "상냥한 시선",
      Bouderic: "지능",
      Charity: "자선",
      "Cherishing kinsmen": "가족을 아끼는 것",
      "Chiding the heart": "마음을 책망하는 것",
      Compassion: "연민",
      "Courage before councils": "회의 앞에서의 용기",
      Courtesy: "예의",
      "Curbing of desire": "욕망을 억제하는 것",
      "Decorum defied": "예의를 거스르는 것",
      "Deliberation before action": "행동 전의 고려",
      Destiny: "운명",
      "Divining the mind": "마음을 읽는 것",
      "Dread of beggary": "거지됨을 두려워하는 것",
      "Dream visions": "꿈의 비전",
      "Duty to society": "사회에 대한 의무",
      Education: "교육",
      "Embrace bliss": "행복을 포옹하는 것",
      Energy: "에너지",
      Equity: "공정",
      Espionage: "첩보 활동",
      "Eventide sigh": "저녁의 한숨",
      "False friendship": "거짓 우정",
      Farming: "농업",
      "Fear of sin": "죄에 대한 두려움",
      "Feeling surmised": "추측되는 감정",
      "Feigned anger": "가짜 분노",
      Folly: "어리석음",
      Forgiveness: "용서",
      Fortress: "요새",
      "Freedom from sloth": "게으름에서 자유",
      Friendship: "우정",
      "Futile wealth": "무의미한 재산",
      "Gaining great men's help": "위대한 남자의 도움을 얻는 것",
      Gambling: "도박",
      "Good decorum": "좋은 예의",
      Gratitude: "감사",
      Greatness: "위대함",
      Hatred: "혐오",
      Honour: "명예",
      "Hope in mishap": "불행 속의 희망",
      Hospitality: "접대",
      Imposture: "사기",
      Instability: "불안정",
      Intimacy: "밀접",
      "Judging strength": "힘을 판단하는 것",
      "Judging the audience": "청중을 판단하는 것",
      "Judging the place": "장소를 판단하는 것",
      "Just government": "정의로운 정부",
      "Knowing proper time": "적절한 시간을 알리는 것",
      "Limbs languish": "사지가 약해지는 것",
      Listening: "듣는 것",
      "Longing for reunion": "재회를 열망하는 것",
      "Love's excellence": "사랑의 우수함",
      "Loving-kindness": "사랑과 친절",
      "Manly effort": "남성적인 노력",
      "Married Life": "결혼 생활",
      Meanness: "치사함",
      Medicine: "의학",
      "Military pride": "군사적 자부심",
      Ministers: "장관들",
      "Modes of action": "행동 방식",
      "Mutual yearning": "상호 간의 열망",
      Nobility: "귀족성",
      "Noble hostility": "귀족적인 적대감",
      "Non- learning": "학습하지 않음",
      "Non-killing": "살인을 하지 않음",
      "Non-violence": "폭력을 행하지 않음",
      "Not drinking liquor": "술을 마시지 않음",
      "Offend not the great": "위대한 이를冒犯하지 말라",
      "Pangs of separation": "이별의 고통",
      Penance: "참회",
      "Petty conceit": "소심한 자만",
      "Pining alone": "홀로 애태워하는 것",
      Poverty: "빈곤",
      "Power of speech": "언변의 힘",
      "Powerful acts": "강력한 행위",
      "Promoting family welfare": "가족 복지를 증진시키는 것",
      "Public clamour": "공공의 소란",
      "Purity of action": "행동의 순수",
      Renown: "명성",
      Renunciation: "포기",
      "Reserve lost": "예비가 손실된 것",
      "Restraining anger": "분노를 억제하는 것",
      "Sad memories": "슬픈 추억",
      "Secret foe": "비밀 적",
      "Self-control": "자제",
      "Sensitiveness to shame": "수치에 대한 민감성",
      "Signs speak the heart": "징후가 마음을 말하는 것",
      Soliloquy: "독백",
      Sublimity: "고상함",
      "Sulking charm": "성내는 매력",
      "Sweet words": "달콤한 말",
      "Testing and entrusting": "시험하고 믿는 것",
      "Testing friendship": "우정을 시험하는 것",
      "Testing of men for confidence": "신뢰를 위한 남성의 시험",
      "The absence of fraud": "사기의 부재",
      "The blessing of Rain": "비의 축복",
      "The country": "나라",
      "The cruel tyranny": "잔인한 독재",
      "The embassy": "대사관",
      "The glory of army": "군대의 영광",
      "The grandeur of monarchy": "군주제의 웅장함",
      "The merit of Ascetics": "수행자의 공로",
      "The possession of knowledge": "지식의 소유",
      "The power of virtue": "덕의 힘",
      "The praise of God": "신의 찬양",
      "The wealth of children": "자녀의 재산",
      "The worth of a wife": "아내의 가치",
      "Truth consciousness": "진실의 의식",
      Unforgetfulness: "잊지 않음",
      Veracity: "진실성",
      "Wailing of pining love": "행복의 슬픔",
      "Wailing over pallor": "흑반의 슬픔",
      "Walk with kings": "왕들과 걸어가는 것",
      "Wanton women": "나쁜 여자",
      "Wasteful look for wistful love": "슬픔의 눈빛",
      "Way of making wealth": "재산을 만드는 방법",
    },
    malay: {
      "Abstinence from flesh": "Penghindaran dari daging",
      "Against coveting another's wife":
        "Menentang keinginan terhadap isteri orang lain",
      "Against covetousness": "Menentang keserakahan",
      "Against slander": "Menentang fitnah",
      "Against vain speaking": "Menentang percakapan sia-sia",
      "Apparising enemies": "Mengenal pasti musuh",
      Asking: "Bertanya",
      "Avoid envy": "Hindari iri hati",
      "Avoiding faults": "Mengelakkan kesalahan",
      "Avoiding mean company": "Mengelakkan syarikat yang buruk",
      "Avoiding terrorism": "Mengelakkan keganasan",
      "Bad friendship": "Persahabatan yang buruk",
      "Beauty extolled": "Kecantikan yang dipuji",
      "Beauty's dart": "Panah kecantikan",
      "Being led by women": "Dipimpin oleh wanita",
      "Benign looks": "Pandangan yang lembut",
      Bouderic: "Kecerdasan",
      Charity: "Sedekah",
      "Cherishing kinsmen": "Menghargai sanak saudara",
      "Chiding the heart": "Menegur hati",
      Compassion: "Belas kasihan",
      "Courage before councils": "Keberanian di hadapan majlis",
      Courtesy: "Sopan santun",
      "Curbing of desire": "Mengawal keinginan",
      "Decorum defied": "Sopan santun yang dilanggar",
      "Deliberation before action": "Pertimbangan sebelum tindakan",
      Destiny: "Nasib",
      "Divining the mind": "Membaca fikiran",
      "Dread of beggary": "Takut kepada kemiskinan",
      "Dream visions": "Visi mimpi",
      "Duty to society": "Tugas kepada masyarakat",
      Education: "Pendidikan",
      "Embrace bliss": "Menggapai kebahagiaan",
      Energy: "Tenaga",
      Equity: "Keadilan",
      Espionage: "Pengintipan",
      "Eventide sigh": "Tangisan senja",
      "False friendship": "Persahabatan palsu",
      Farming: "Pertanian",
      "Fear of sin": "Takut kepada dosa",
      "Feeling surmised": "Perasaan yang disangka",
      "Feigned anger": "Marah yang dibuat-buat",
      Folly: "Kebodohan",
      Forgiveness: "Pengampunan",
      Fortress: "Kubu",
      "Freedom from sloth": "Kebebasan dari kemalasan",
      Friendship: "Persahabatan",
      "Futile wealth": "Kekayaan yang sia-sia",
      "Gaining great men's help": "Mendapatkan bantuan orang besar",
      Gambling: "Berjudi",
      "Good decorum": "Sopan santun yang baik",
      Gratitude: "Rasa terima kasih",
      Greatness: "Kebesaran",
      Hatred: "Kebencian",
      Honour: "Hormat",
      "Hope in mishap": "Harapan dalam malapetaka",
      Hospitality: "Kesediaan",
      Imposture: "Penipuan",
      Instability: "Ketidakstabilan",
      Intimacy: "Kemesraan",
      "Judging strength": "Menilai kekuatan",
      "Judging the audience": "Menilai penonton",
      "Judging the place": "Menilai tempat",
      "Just government": "Pemerintahan yang adil",
      "Knowing proper time": "Mengetahui waktu yang sesuai",
      "Limbs languish": "Anggota badan yang lemah",
      Listening: "Mendengar",
      "Longing for reunion": "Rindu akan pertemuan",
      "Love's excellence": "Kecemerlangan cinta",
      "Loving-kindness": "Kasih sayang",
      "Manly effort": "Usaha yang gagah",
      "Married Life": "Hidup berkahwin",
      Meanness: "Kebakhilan",
      Medicine: "Perubatan",
      "Military pride": "Kebanggaan tentera",
      Ministers: "Menteri-menteri",
      "Modes of action": "Cara-cara tindakan",
      "Mutual yearning": "Rindu yang timbal balik",
      Nobility: "Kebangsawanan",
      "Noble hostility": "Kebencian yang bangsawan",
      "Non- learning": "Tidak belajar",
      "Non-killing": "Tidak membunuh",
      "Non-violence": "Tidak berkelahi",
      "Not drinking liquor": "Tidak minum arak",
      "Offend not the great": "Jangan menghina orang besar",
      "Pangs of separation": "Sakit hati karena berpisah",
      Penance: "Penebusan",
      "Petty conceit": "Kesombongan yang kecil",
      "Pining alone": "Mengidam sendiri",
      Poverty: "Kemiskinan",
      "Power of speech": "Kuasa bicara",
      "Powerful acts": "Tindakan yang kuat",
      "Promoting family welfare": "Menggalakkan kesejahteraan keluarga",
      "Public clamour": "Kebisingan awam",
      "Purity of action": "Kesucian tindakan",
      Renown: "Kemasyhuran",
      Renunciation: "Pengunduran diri",
      "Reserve lost": "Simpanan yang hilang",
      "Restraining anger": "Mengawal marah",
      "Sad memories": "Kenangan yang sedih",
      "Secret foe": "Musuh yang rahsia",
      "Self-control": "Kawalan diri",
      "Sensitiveness to shame": "Kesensitifan terhadap malu",
      "Signs speak the heart": "Tanda-tanda yang bercakap dari hati",
      Soliloquy: "Monolog",
      Sublimity: "Ketinggian",
      "Sulking charm": "Daya tarik yang murung",
      "Sweet words": "Kata-kata yang manis",
      "Testing and entrusting": "Menguji dan mempercayai",
      "Testing friendship": "Menguji persahabatan",
      "Testing of men for confidence": "Menguji lelaki untuk kepercayaan",
      "The absence of fraud": "Ketiadaan penipuan",
      "The blessing of Rain": "Berkat hujan",
      "The country": "Negara",
      "The cruel tyranny": "Tirani yang kejam",
      "The embassy": "Kedutaan",
      "The glory of army": "Kemuliaan tentera",
      "The grandeur of monarchy": "Kemegahan monarki",
      "The merit of Ascetics": "Kebaikan Asketik",
      "The possession of knowledge": "Pemilikan pengetahuan",
      "The power of virtue": "Kuasa kebajikan",
      "The praise of God": "Pujian Tuhan",
      "The wealth of children": "Kekayaan anak-anak",
      "The worth of a wife": "Nilai seorang isteri",
      "Truth consciousness": "Sedaran kebenaran",
      Unforgetfulness: "Tidak lupa",
      Veracity: "Kebenaran",
      "Wailing of pining love": "Gelisahkan cinta",
      "Wailing over pallor": "Gelisahkan karena kemabaran",
      "Walk with kings": "Berjalan dengan raja",
      "Wanton women": "Orang wanita yang tidak bermoral",
      "Wasteful look for wistful love":
        "Tampilan yang boros untuk cinta yang sedih",
      "Way of making wealth": "Cara membuat kekayaan",
    },
    malayalam: {
      "Abstinence from flesh": "മാംസത്യാഗം",
      "Against coveting another's wife":
        "മറ്റൊരാളിന്റെ ഭാര്യയെ ആഗ്രഹിക്കുന്നതിനെതിരെ",
      "Against covetousness": "ലോഭത്തിനെതിരെ",
      "Against slander": "നിന്ദയ്ക്കെതിരെ",
      "Against vain speaking": "വ്യര്ഥമായ സംഭാഷണത്തിനെതിരെ",
      "Apparising enemies": "ശത്രുക്കളെ തിരിച്ചറിയുന്നത്",
      Asking: "ചോദ്യം ചെയ്യുന്നത്",
      "Avoid envy": "അസൂയ ഒഴിവാക്കുക",
      "Avoiding faults": "തെറ്റുകൾ ഒഴിവാക്കുന്നത്",
      "Avoiding mean company": "ദുഷ്ടസംഗതി ഒഴിവാക്കുന്നത്",
      "Avoiding terrorism": "ഭീകരത ഒഴിവാക്കുന്നത്",
      "Bad friendship": "ദുഷ്ടസൗഹൃദം",
      "Beauty extolled": "സൗന്ദര്യം പ്രശംസിക്കുന്നത്",
      "Beauty's dart": "സൗന്ദര്യത്തിന്റെ അമ്പ്",
      "Being led by women": "സ്ത്രീകളാൽ നയിക്കപ്പെടുന്നത്",
      "Benign looks": "സൗമ്യദൃഷ്ടി",
      Bouderic: "ബൗദ്ധികം",
      Charity: "ദാനം",
      "Cherishing kinsmen": "ബന്ധുക്കളെ സ്നേഹിക്കുന്നത്",
      "Chiding the heart": "ഹൃദയത്തെ തിരുത്തുന്നത്",
      Compassion: "കരുണ",
      "Courage before councils": "സഭകളിൽ ധൈര്യം",
      Courtesy: "സദാചാരം",
      "Curbing of desire": "ആഗ്രഹത്തിന്റെ നിയന്ത്രണം",
      "Decorum defied": "സദാചാരം ലംഘിക്കുന്നത്",
      "Deliberation before action": "പ്രവൃത്തിക്കു മുമ്പുള്ള ചിന്ത",
      Destiny: "വിധി",
      "Divining the mind": "മനസ്സ് വായിക്കുന്നത്",
      "Dread of beggary": "ഭിക്ഷാടനത്തിന്റെ ഭയം",
      "Dream visions": "സ്വപ്നദൃഷ്ടി",
      "Duty to society": "സമൂഹത്തിന്റെ കടമ",
      Education: "വിദ്യാഭ്യാസം",
      "Embrace bliss": "സുഖം സ്വീകരിക്കുന്നത്",
      Energy: "ഊർജ്ജം",
      Equity: "സമത്വം",
      Espionage: "ചാരവൃത്തി",
      "Eventide sigh": "സന്ധ്യാസൂചന",
      "False friendship": "അസത്യസൗഹൃദം",
      Farming: "കൃഷി",
      "Fear of sin": "പാപഭയം",
      "Feeling surmised": "സംശയിക്കുന്നത്",
      "Feigned anger": "നടിക്കുന്ന ക്രോധം",
      Folly: "മൂഢത",
      Forgiveness: "ക്ഷമ",
      Fortress: "കോട്ട",
      "Freedom from sloth": "അലസതയിൽ നിന്നുള്ള സ്വാതന്ത്ര്യം",
      Friendship: "സൗഹൃദം",
      "Futile wealth": "നിഷ്ഫലമായ സമ്പത്ത്",
      "Gaining great men's help": "മഹാന്മാരുടെ സഹായം നേടുന്നത്",
      Gambling: "ജൂവാ",
      "Good decorum": "നല്ല സദാചാരം",
      Gratitude: "കൃതജ്ഞത",
      Greatness: "മഹത്വം",
      Hatred: "വെറുപ്പ്",
      Honour: "സമ്മാനം",
      "Hope in mishap": "അപകടത്തിൽ ആശ",
      Hospitality: "അതിഥിസത്കാരം",
      Imposture: "വഞ്ചന",
      Instability: "അസ്ഥിരത",
      Intimacy: "അടുപ്പം",
      "Judging strength": "ശക്തി വിലയിരുത്തുന്നത്",
      "Judging the audience": "പ്രേക്ഷകരെ വിലയിരുത്തുന്നത്",
      "Judging the place": "സ്ഥലം വിലയിരുത്തുന്നത്",
      "Just government": "ന്യായമായ ഭരണം",
      "Knowing proper time": "സമയം അറിയുന്നത്",
      "Limbs languish": "അവയവങ്ങൾ ദുർബലമാകുന്നത്",
      Listening: "കേൾവി",
      "Longing for reunion": "പുനഃസംഗമത്തിന്റെ ആഗ്രഹം",
      "Love's excellence": "പ്രേമത്തിന്റെ ഉത്തമത",
      "Loving-kindness": "സ്നേഹം",
      "Manly effort": "പുരുഷാരം",
      "Married Life": "വിവാഹജീവിതം",
      Meanness: "കുറവ്",
      Medicine: "ഔഷധം",
      "Military pride": "സൈനികമാനം",
      Ministers: "മന്ത്രിമാർ",
      "Modes of action": "പ്രവൃത്തിമാർഗങ്ങൾ",
      "Mutual yearning": "പരസ്പരമായ ആഗ്രഹം",
      Nobility: "ഉന്നതി",
      "Noble hostility": "ഉന്നതമായ ശത്രുത",
      "Non- learning": "അപരിചയം",
      "Non-killing": "അഹിംസ",
      "Non-violence": "അഹിംസാ",
      "Not drinking liquor": "മദ്യം കുടിക്കാതിരിക്കുന്നത്",
      "Offend not the great": "മഹാന്മാരെ അപമാനിക്കാതിരിക്കുക",
      "Pangs of separation": "വിയോഗസംവേദന",
      Penance: "പ്രായശ്ചിത്തം",
      "Petty conceit": "ചെറിയ അഹംഭാവം",
      "Pining alone": "ഏകാകിപ്പിന്നുന്നത്",
      Poverty: "ദാരിദ്ര്യം",
      "Power of speech": "വാക്ചക്തി",
      "Powerful acts": "ശക്തമായ പ്രവൃത്തികൾ",
      "Promoting family welfare": "കുടുംബക്ഷേമം പ്രോത്സാഹിപ്പിക്കുന്നത്",
      "Public clamour": "ജനസംഘം",
      "Purity of action": "പ്രവൃത്തിയുടെ ശുദ്ധി",
      Renown: "പ്രസിദ്ധി",
      Renunciation: "സന്ന്യാസം",
      "Reserve lost": "സംരക്ഷണം നഷ്ടപ്പെടുന്നത്",
      "Restraining anger": "ക്രോധം അടക്കുന്നത്",
      "Sad memories": "ദുഃഖകരമായ സ്മരണകൾ",
      "Secret foe": "രഹസ്യമായ ശത്രു",
      "Self-control": "സ്വയംനിയന്ത്രണം",
      "Sensitiveness to shame": "ലജ്ജയ്ക്കുള്ള സംവേദനം",
      "Signs speak the heart": "ഹൃദയം സംസാരിക്കുന്ന ചിഹ്നങ്ങൾ",
      Soliloquy: "ഏകാംഗസംഭാഷണം",
      Sublimity: "ഉന്നതി",
      "Sulking charm": "മുഖംകുളിക്കുന്ന ആകർഷണം",
      "Sweet words": "മധുരവാക്കുകൾ",
      "Testing and entrusting": "പരീക്ഷിക്കുകയും വിശ്വസിക്കുകയും",
      "Testing friendship": "സൗഹൃദം പരീക്ഷിക്കുക",
      "Testing of men for confidence":
        "വിശ്വാസത്തിനായി പുരുഷന്മാരെ പരീക്ഷിക്കുക",
      "The absence of fraud": "വഞ്ചനയുടെ അഭാവം",
      "The blessing of Rain": "മഴയുടെ അനുഗ്രഹം",
      "The country": "രാജ്യം",
      "The cruel tyranny": "ക്രൂരമായ അടിച്ചുപിടിക്കൽ",
      "The embassy": "സംസ്ഥാനം",
      "The glory of army": "സൈന്യത്തിന്റെ മഹത്വം",
      "The grandeur of monarchy": "രാജവംശത്തിന്റെ മഹത്വം",
      "The merit of Ascetics": "സന്ന്യാസികളുടെ ഗുണം",
      "The possession of knowledge": "ജ്ഞാനത്തിന്റെ സ്വായത്ത",
      "The power of virtue": "ധർമ്മത്തിന്റെ ശക്തി",
      "The praise of God": "ദൈവസ്തുതി",
      "The wealth of children": "കുട്ടികളുടെ സമ്പത്ത്",
      "The worth of a wife": "ഭാര്യയുടെ മൂല്യം",
      "Truth consciousness": "സത്യസംവേദന",
      Unforgetfulness: "മറവിയില്ലായ്മ",
      Veracity: "സത്യം",
      "Wailing of pining love": "പ്രേമയുടെ ദുഃഖം ഗുസ്സാവാനി",
      "Wailing over pallor": "പലരെ ബാധിക്കുന്ന ഗുസ്സാവാനി",
      "Walk with kings": "ശാസ്ത്രിക്കുക",
      "Wanton women": "ബെച്ചന്റെ സ്ത്രീകൾ",
      "Wasteful look for wistful love": "പ്രേമയുടെ ദുഃഖം ഗുസ്സാവാനി",
      "Way of making wealth": "ധനം നേടിക്കുന്ന രാസ്ത്രി",
    },
    polish: {
      "Abstinence from flesh": "Wstrzemięźliwość od mięsa",
      "Against coveting another's wife": "Przeciwko pożądaniu żony innego",
      "Against covetousness": "Przeciwko chciwości",
      "Against slander": "Przeciwko oszczerstwu",
      "Against vain speaking": "Przeciwko mówieniu na próżno",
      "Apparising enemies": "Ostrzeganie wrogów",
      Asking: "Pytanie",
      "Avoid envy": "Unikaj zazdrości",
      "Avoiding faults": "Unikanie wad",
      "Avoiding mean company": "Unikanie towarzystwa niskich",
      "Avoiding terrorism": "Unikanie terroryzmu",
      "Bad friendship": "Zła przyjaźń",
      "Beauty extolled": "Wychwalanie piękna",
      "Beauty's dart": "Strzała piękna",
      "Being led by women": "Bycie prowadzonym przez kobiety",
      "Benign looks": "Łagodne spojrzenia",
      Bouderic: "Bouderic",
      Charity: "Miłosierdzie",
      "Cherishing kinsmen": "Pielęgnowanie krewnych",
      "Chiding the heart": "Karanie serca",
      Compassion: "Współczucie",
      "Courage before councils": "Odwaga przed radami",
      Courtesy: "Uprzejmość",
      "Curbing of desire": "Opanowanie pragnienia",
      "Decorum defied": "Pogarda dla przyzwoitości",
      "Deliberation before action": "Rozważanie przed działaniem",
      Destiny: "Przeznaczenie",
      "Divining the mind": "Przewidywanie umysłu",
      "Dread of beggary": "Strach przed żebractwem",
      "Dream visions": "Wizje snów",
      "Duty to society": "Obowiązek wobec społeczeństwa",
      Education: "Edukacja",
      "Embrace bliss": "Obejmij błogość",
      Energy: "Energia",
      Equity: "Równość",
      Espionage: "Szpiegostwo",
      "Eventide sigh": "Wzdychanie zmierzchu",
      "False friendship": "Fałszywa przyjaźń",
      Farming: "Rolnictwo",
      "Fear of sin": "Strach przed grzechem",
      "Feeling surmised": "Odczuwanie domniemania",
      "Feigned anger": "Symulowany gniew",
      Folly: "Głupota",
      Forgiveness: "Przebaczenie",
      Fortress: "Twierdza",
      "Freedom from sloth": "Wolność od lenistwa",
      Friendship: "Przyjaźń",
      "Futile wealth": "Bezowocne bogactwo",
      "Gaining great men's help": "Zdobywanie pomocy wielkich ludzi",
      Gambling: "Hazard",
      "Good decorum": "Dobry obyczaj",
      Gratitude: "Wdzięczność",
      Greatness: "Wielkość",
      Hatred: "Nienawiść",
      Honour: "Honor",
      "Hope in mishap": "Nadzieja w nieszczęściu",
      Hospitality: "Gościnność",
      Imposture: "Oszustwo",
      Instability: "Niestabilność",
      Intimacy: "Bliskość",
      "Judging strength": "Ocenianie siły",
      "Judging the audience": "Ocenianie publiczności",
      "Judging the place": "Ocenianie miejsca",
      "Just government": "Sprawiedliwe rządy",
      "Knowing proper time": "Znając właściwy czas",
      "Limbs languish": "Kończyny więdną",
      Listening: "Słuchanie",
      "Longing for reunion": "Tęsknota za ponownym spotkaniem",
      "Love's excellence": "Doskonałość miłości",
      "Loving-kindness": "Miłość i życzliwość",
      "Manly effort": "Męskie wysiłki",
      "Married Life": "Życie małżeńskie",
      Meanness: "Podłość",
      Medicine: "Medycyna",
      "Military pride": "Duma wojskowa",
      Ministers: "Ministrowie",
      "Modes of action": "Sposoby działania",
      "Mutual yearning": "Wzajemna tęsknota",
      Nobility: "Szlachetność",
      "Noble hostility": "Szlachetna wrogość",
      "Non- learning": "Brak nauki",
      "Non-killing": "Nie zabijanie",
      "Non-violence": "Bez przemocy",
      "Not drinking liquor": "Nie picie alkoholu",
      "Offend not the great": "Nie obrażaj wielkich",
      "Pangs of separation": "Bóle rozłąki",
      Penance: "Pokuta",
      "Petty conceit": "Drobne zarozumialstwo",
      "Pining alone": "Tęsknota w samotności",
      Poverty: "Bieda",
      "Power of speech": "Moc mowy",
      "Powerful acts": "Potężne czyny",
      "Promoting family welfare": "Promowanie dobrobytu rodziny",
      "Public clamour": "Publiczny hałas",
      "Purity of action": "Czystość działania",
      Renown: "Sława",
      Renunciation: "Rezygnacja",
      "Reserve lost": "Utracona rezerwa",
      "Restraining anger": "Opanowanie gniewu",
      "Sad memories": "Smutne wspomnienia",
      "Secret foe": "Tajny wróg",
      "Self-control": "Samokontrola",
      "Sensitiveness to shame": "Wrażliwość na wstyd",
      "Signs speak the heart": "Znaki mówiące serce",
      Soliloquy: "Monolog",
      Sublimity: "Wzniosłość",
      "Sulking charm": "Urok drażnienia",
      "Sweet words": "Słodkie słowa",
      "Testing and entrusting": "Testowanie i powierzanie",
      "Testing friendship": "Testowanie przyjaźni",
      "Testing of men for confidence": "Testowanie mężczyzn dla zaufania",
      "The absence of fraud": "Brak oszustwa",
      "The blessing of Rain": "Błogosławieństwo deszczu",
      "The country": "Kraj",
      "The cruel tyranny": "Okrutna tyrania",
      "The embassy": "Ambasada",
      "The glory of army": "Chwała armii",
      "The grandeur of monarchy": "Wielkość monarchii",
      "The merit of Ascetics": "Zasługa ascetów",
      "The possession of knowledge": "Posiadanie wiedzy",
      "The power of virtue": "Moc cnoty",
      "The praise of God": "Chwała Boga",
      "The wealth of children": "Bogactwo dzieci",
      "The worth of a wife": "Wartość żony",
      "Truth consciousness": "Świadomość prawdy",
      Unforgetfulness: "Niezapomnienie",
      Veracity: "Prawdomówność",
      "Wailing of pining love": "Głosy płaczącej miłości",
      "Wailing over pallor": "Głosy płaczącej miłości",
      "Walk with kings": "Ścieżka z władcami",
      "Wanton women": "Będące wśród wdzięcznych",
      "Wasteful look for wistful love": "Widząc wśród wdzięcznych",
      "Way of making wealth": "Ścieżka z władcami",
    },
    russian: {
      "Abstinence from flesh": "Воздержание от мяса",
      "Against coveting another's wife": "Против посягательства на чужую жену",
      "Against covetousness": "Против алчности",
      "Against slander": "Против клеветы",
      "Against vain speaking": "Против пустословия",
      "Apparising enemies": "Предупреждение врагов",
      Asking: "Спрашивание",
      "Avoid envy": "Избегай зависти",
      "Avoiding faults": "Избегание ошибок",
      "Avoiding mean company": "Избегание низменного общества",
      "Avoiding terrorism": "Избегание терроризма",
      "Bad friendship": "Плохая дружба",
      "Beauty extolled": "Восхваление красоты",
      "Beauty's dart": "Стрела красоты",
      "Being led by women": "Быть руководимым женщинами",
      "Benign looks": "Добрые взгляды",
      Bouderic: "Будерик",
      Charity: "Милосердие",
      "Cherishing kinsmen": "Ухаживание за родственниками",
      "Chiding the heart": "Упреки сердцу",
      Compassion: "Сострадание",
      "Courage before councils": "Храбрость перед советами",
      Courtesy: "Вежливость",
      "Curbing of desire": "Укрощение желания",
      "Decorum defied": "Пренебрежение приличиями",
      "Deliberation before action": "Рассмотрение перед действием",
      Destiny: "Судьба",
      "Divining the mind": "Проникновение в ум",
      "Dread of beggary": "Страх нищеты",
      "Dream visions": "Видения снов",
      "Duty to society": "Обязанность перед обществом",
      Education: "Образование",
      "Embrace bliss": "Обними блаженство",
      Energy: "Энергия",
      Equity: "Справедливость",
      Espionage: "Шпионаж",
      "Eventide sigh": "Вздох вечера",
      "False friendship": "Ложная дружба",
      Farming: "Сельское хозяйство",
      "Fear of sin": "Страх греха",
      "Feeling surmised": "Чувство предположения",
      "Feigned anger": "Симулированный гнев",
      Folly: "Глупость",
      Forgiveness: "Прощение",
      Fortress: "Крепость",
      "Freedom from sloth": "Свобода от лени",
      Friendship: "Дружба",
      "Futile wealth": "Бесполезное богатство",
      "Gaining great men's help": "Получение помощи великих людей",
      Gambling: "Азартные игры",
      "Good decorum": "Хороший обyczaj",
      Gratitude: "Благодарность",
      Greatness: "Величие",
      Hatred: "Ненависть",
      Honour: "Честь",
      "Hope in mishap": "Надежда в беде",
      Hospitality: "Гостеприимство",
      Imposture: "Обман",
      Instability: "Нестабильность",
      Intimacy: "Близость",
      "Judging strength": "Оценка силы",
      "Judging the audience": "Оценка аудитории",
      "Judging the place": "Оценка места",
      "Just government": "Справедливое правление",
      "Knowing proper time": "Знание подходящего времени",
      "Limbs languish": "Члены увядают",
      Listening: "Слушание",
      "Longing for reunion": "Тоска по воссоединению",
      "Love's excellence": "Превосходство любви",
      "Loving-kindness": "Любовь и доброжелательность",
      "Manly effort": "Мужественные усилия",
      "Married Life": "Семейная жизнь",
      Meanness: "Подлость",
      Medicine: "Медицина",
      "Military pride": "Военная гордость",
      Ministers: "Министры",
      "Modes of action": "Способы действия",
      "Mutual yearning": "Взаимная тоска",
      Nobility: "Благородство",
      "Noble hostility": "Благородная вражда",
      "Non- learning": "Безучие",
      "Non-killing": "Ненасилие",
      "Non-violence": "Беспримесность",
      "Not drinking liquor": "Не пить алкоголь",
      "Offend not the great": "Не обижай великих",
      "Pangs of separation": "Боли разлуки",
      Penance: "Покаяние",
      "Petty conceit": "Мелочная самонадеянность",
      "Pining alone": "Тоска в одиночестве",
      Poverty: "Бедность",
      "Power of speech": "Сила речи",
      "Powerful acts": "Мощные деяния",
      "Promoting family welfare": "Содействие благополучию семьи",
      "Public clamour": "Публичный шум",
      "Purity of action": "Чистота действия",
      Renown: "Слава",
      Renunciation: "Отречение",
      "Reserve lost": "Утраченный резерв",
      "Restraining anger": "Укрощение гнева",
      "Sad memories": "Грустные воспоминания",
      "Secret foe": "Тайный враг",
      "Self-control": "Самоконтроль",
      "Sensitiveness to shame": "Чувствительность к стыду",
      "Signs speak the heart": "Знаки говорят сердце",
      Soliloquy: "Монолог",
      Sublimity: "Возвышенность",
      "Sulking charm": "Обаяние уныния",
      "Sweet words": "Сладкие слова",
      "Testing and entrusting": "Тестирование и доверие",
      "Testing friendship": "Тестирование дружбы",
      "Testing of men for confidence": "Тестирование мужчин для доверия",
      "The absence of fraud": "Отсутствие обмана",
      "The blessing of Rain": "Благословение дождя",
      "The country": "Страна",
      "The cruel tyranny": "Жестокая тирания",
      "The embassy": "Посольство",
      "The glory of army": "Слава армии",
      "The grandeur of monarchy": "Величие монархии",
      "The merit of Ascetics": "Заслуга аскетов",
      "The possession of knowledge": "Владение знанием",
      "The power of virtue": "Сила добродетели",
      "The praise of God": "Хвала Богу",
      "The wealth of children": "Богатство детей",
      "The worth of a wife": "Ценность жены",
      "Truth consciousness": "Сознание истины",
      Unforgetfulness: "Незабывчивость",
      Veracity: "Истина",
      "Wailing of pining love": "Скрип души влюбленного",
      "Wailing over pallor": "Скрип души от бледности",
      "Walk with kings": "Служба королям",
      "Wanton women": "Безрассудные женщины",
      "Wasteful look for wistful love": "Взгляд на бледность влюбленного",
      "Way of making wealth": "Способ создания богатства",
    },
    singalam: {
      "Abstinence from flesh": "මාංස විමුක්තිය",
      "Against coveting another's wife": "අන්නගේ බිරියට ආශා කිරීමට විරුද්ධව",
      "Against covetousness": "ලෝභයට විරුද්ධව",
      "Against slander": "නින්දාවට විරුද්ධව",
      "Against vain speaking": "ව්‍යර්ථ කථාවට විරුද්ධව",
      "Apparising enemies": "සතුරන් පෙන්වීම",
      Asking: "ඇසීම",
      "Avoid envy": "අසුරු ඉක්මවීම",
      "Avoiding faults": "දෝෂ ඉක්මවීම",
      "Avoiding mean company": "පහත් සමාගම ඉක්මවීම",
      "Avoiding terrorism": "ත්‍රස්තවාදය ඉක්මවීම",
      "Bad friendship": "නරක මිත්‍රත්වය",
      "Beauty extolled": "සුන්දරත්වය ප්‍රශංසා කිරීම",
      "Beauty's dart": "සුන්දරත්වයේ හීය",
      "Being led by women": "ාන්තාවන් විසින් මෙහෙයවීම",
      "Benign looks": "සුන්දර බැලුම්",
      Bouderic: "බුදේරික්",
      Charity: "දානය",
      "Cherishing kinsmen": "ඥාතීන් ආදරය කිරීම",
      "Chiding the heart": "හදවත තැතීම",
      Compassion: "කරුණාව",
      "Courage before councils": "මන්ත්‍රී මණ්ඩල ඉදිරියේ සාහසිකත්වය",
      Courtesy: "සමාධානය",
      "Curbing of desire": "ආශාව පාලනය",
      "Decorum defied": "සම්මතය ප්‍රතික්ෂේප කිරීම",
      "Deliberation before action": "්‍රියාවට පෙර විමසීම",
      Destiny: "පෙරදිගුම",
      "Divining the mind": "මනස පෙන්වීම",
      "Dread of beggary": "දුප්පත්කමේ භය",
      "Dream visions": "සිහින් දර්ශන",
      "Duty to society": "සමාජයට යුතුකම",
      Education: "අධ්‍යාපනය",
      "Embrace bliss": "සුඛය අනුගමනය",
      Energy: "ශක්තිය",
      Equity: "සමතාව",
      Espionage: "ජාසුස්කම",
      "Eventide sigh": "සන්ධ්‍යාවේ හුස්ම",
      "False friendship": "අසත්‍ය මිත්‍රත්වය",
      Farming: "කෘෂිකර්මය",
      "Fear of sin": "පාපයේ භය",
      "Feeling surmised": "නුමානය කිරීම",
      "Feigned anger": "ප්‍රකට කෝපය",
      Folly: "මුගුනාත්මකත්වය",
      Forgiveness: "සමාව",
      Fortress: "කොටුව",
      "Freedom from sloth": "අලසයෙන් නිදහස",
      Friendship: "මිත්‍රත්වය",
      "Futile wealth": "අනාගතයේ ධනය",
      "Gaining great men's help": "මහා පුරුෂයන්ගේ උදවු ලබාගැනීම",
      Gambling: "ජුවාම්පල",
      "Good decorum": "හොඳ සම්මතය",
      Gratitude: "කෘතගුණය",
      Greatness: "මහත්මය",
      Hatred: "වෛරය",
      Honour: "සම්මානය",
      "Hope in mishap": "අනතුරේ බලාපොරොත්තුව",
      Hospitality: "අතිත්ථිය",
      Imposture: "ප්‍රතිරූපය",
      Instability: "අස්ථායීත්වය",
      Intimacy: "ආදරය",
      "Judging strength": "බලය පිළිබඳ විනිශ්චය",
      "Judging the audience": "ශ්‍රෝත්‍රීන් පිළිබඳ විනිශ්චය",
      "Judging the place": "ස්ථානය පිළිබඳ විනිශ්චය",
      "Just government": "නීතියානුකූල රජය",
      "Knowing proper time": "සුදුසු කාලය දැනීම",
      "Limbs languish": "අංග දුර්වලත්වය",
      Listening: "සවන් දීම",
      "Longing for reunion": "යළි එක්වීමේ ආශාව",
      "Love's excellence": "ආදරයේ උත්කෘෂ්ටත්වය",
      "Loving-kindness": "ආදරය සහ මෛත්‍රීය",
      "Manly effort": "පුරුෂත්වයේ උත්සාහය",
      "Married Life": "විවාහය",
      Meanness: "පහත්කම",
      Medicine: "වෙදකම",
      "Military pride": "සෙන්ගේ ගෞරවය",
      Ministers: "අමාත්‍යවරු",
      "Modes of action": "්‍රියාකාරකම්",
      "Mutual yearning": "පරස්පර ආශාව",
      Nobility: "ස්වාභිමානය",
      "Noble hostility": "ස්වාභිමාන වෛරය",
      "Non- learning": "අධ්‍යාපනයේ අඩුපාඩුකම",
      "Non-killing": "නොමරනය",
      "Non-violence": "අහිංසාව",
      "Not drinking liquor": "මත්පැන් නොබීම",
      "Offend not the great": "මහාත්මයන්ට අපකාරය නොකිරීම",
      "Pangs of separation": "වෙන්වීමේ දුක්",
      Penance: "ප්‍රායශ්චිත්තය",
      "Petty conceit": "කුඩා අහංකාරය",
      "Pining alone": "තනිව තුවාලුකම",
      Poverty: "දුප්පත්කම",
      "Power of speech": "වාග් බලය",
      "Powerful acts": "බලවත් ක්‍රියා",
      "Promoting family welfare": "පවුලේ සුභ සාධනය",
      "Public clamour": "පොදු හඩය",
      "Purity of action": "්‍රියාවේ පිරිසිදුකම",
      Renown: "ප්‍රසිද්ධිය",
      Renunciation: "පරිත්‍යාගය",
      "Reserve lost": "රැකියාව අහිමි වීම",
      "Restraining anger": "ෝපය පාලනය",
      "Sad memories": "දුක් සිහින",
      "Secret foe": "රහස් සතුරා",
      "Self-control": "ස්වයං පාලනය",
      "Sensitiveness to shame": "ලජ්ජාවට සංවේදනාව",
      "Signs speak the heart": "ලකුණු හදවත කියයි",
      Soliloquy: "මොනොලොග්",
      Sublimity: "විශිෂ්ටත්වය",
      "Sulking charm": "කුඩා ආකර්ෂණය",
      "Sweet words": "සුරතල් වදන්",
      "Testing and entrusting": "පරීක්ෂණය සහ විශ්වාසය",
      "Testing friendship": "මිත්‍රත්වය පරීක්ෂණය",
      "Testing of men for confidence": "විශ්වාසය සඳහා පුරුෂයන් පරීක්ෂණය",
      "The absence of fraud": "ප්‍රතිරූපයේ අඩුපාඩුකම",
      "The blessing of Rain": "වැස්සේ ආශීර්වාදය",
      "The country": "රට",
      "The cruel tyranny": "දැනුම් තිරසාරය",
      "The embassy": "රාජ්‍ය ආරාචකය",
      "The glory of army": "යුද්ධ ස්වරය",
      "The grandeur of monarchy": "රාජ්‍ය විමුක්තිය",
      "The merit of Ascetics": "අභ්‍යාසික ප්‍රස්ථාරය",
      "The possession of knowledge": "දැනුම් අධ්‍යාපනය",
      "The power of virtue": "ද්වාභිමාන සංග්‍යය",
      "The praise of God": "දෙව් ප්‍රස්ථාරය",
      "The wealth of children": "දර්ශම් මහත්වය",
      "The worth of a wife": "දිවාව් අග්‍රය",
      "Truth consciousness": "දිනුම් සංවේදනය",
      Unforgetfulness: "දිනුම් අනුමාපනය",
      Veracity: "දිනුම් සංවේදනය",
      "Wailing of pining love": "ප්‍රේම මිත්‍රත්වයේ දුක්",
      "Wailing over pallor": "ප්‍රේම මිත්‍රත්වයේ දුක්",
      "Walk with kings": "මහත්වයාගේ මන්දය",
      "Wanton women": "ප්‍රේම මිත්‍රත්වයේ දුක්",
      "Wasteful look for wistful love": "ප්‍රේම මිත්‍රත්වයේ දුක්",
      "Way of making wealth": "මිත්‍රත්වයේ දුක්",
    },
    swedish: {
      "Abstinence from flesh": "Avhållsamhet från kött",
      "Against coveting another's wife": "Mot att begära en annans hustru",
      "Against covetousness": "Mot girighet",
      "Against slander": "Mot förtal",
      "Against vain speaking": "Mot tomt prat",
      "Apparising enemies": "Informera fiender",
      Asking: "Fråga",
      "Avoid envy": "Undvik avund",
      "Avoiding faults": "Undvika fel",
      "Avoiding mean company": "Undvika dåligt sällskap",
      "Avoiding terrorism": "Undvika terrorism",
      "Bad friendship": "Dåligt vänskap",
      "Beauty extolled": "Skönhet hyllad",
      "Beauty's dart": "Skönhetens pil",
      "Being led by women": "Ledas av kvinnor",
      "Benign looks": "Vänliga blickar",
      Bouderic: "Bouderic",
      Charity: "Välgörenhet",
      "Cherishing kinsmen": "Värna släktingar",
      "Chiding the heart": "Tillsägelse till hjärtat",
      Compassion: "Medkänsla",
      "Courage before councils": "Mod inför råd",
      Courtesy: "Artighet",
      "Curbing of desire": "Begränsning av begär",
      "Decorum defied": "Anständighet trotsad",
      "Deliberation before action": "Övervägande före handling",
      Destiny: "Öde",
      "Divining the mind": "Spådom av sinnet",
      "Dread of beggary": "Fruktan för tiggeri",
      "Dream visions": "Drömsyner",
      "Duty to society": "Skyldighet gentemot samhället",
      Education: "Utbildning",
      "Embrace bliss": "Omfamna lycka",
      Energy: "Energi",
      Equity: "Rättvisa",
      Espionage: "Spioneri",
      "Eventide sigh": "Aftonens suck",
      "False friendship": "Falskt vänskap",
      Farming: "Jordbruk",
      "Fear of sin": "Fruktan för synd",
      "Feeling surmised": "Känsla förmodad",
      "Feigned anger": "Fejkat ilska",
      Folly: "Dårskap",
      Forgiveness: "Förlåtelse",
      Fortress: "Fästning",
      "Freedom from sloth": "Frihet från lättja",
      Friendship: "Vänskap",
      "Futile wealth": "Förgäves rikedom",
      "Gaining great men's help": "Få stor mäns hjälp",
      Gambling: "Spelande",
      "Good decorum": "God anständighet",
      Gratitude: "Tacksamhet",
      Greatness: "Storhet",
      Hatred: "Hat",
      Honour: "Ära",
      "Hope in mishap": "Hopp i olycka",
      Hospitality: "Gästfrihet",
      Imposture: "Bedrägeri",
      Instability: "Instabilitet",
      Intimacy: "Intimitet",
      "Judging strength": "Bedöma styrka",
      "Judging the audience": "Bedöma publiken",
      "Judging the place": "Bedöma platsen",
      "Just government": "Rättvis regering",
      "Knowing proper time": "Känna rätt tid",
      "Limbs languish": "Lemmar förtvinar",
      Listening: "Lyssna",
      "Longing for reunion": "Längtan efter återförening",
      "Love's excellence": "Kärlekens utmärkelse",
      "Loving-kindness": "Kärleksfullhet",
      "Manly effort": "Manligt ansträngning",
      "Married Life": "Gift liv",
      Meanness: "Snålhet",
      Medicine: "Medicin",
      "Military pride": "Militär stolthet",
      Ministers: "Ministrar",
      "Modes of action": "Handlingsformer",
      "Mutual yearning": "Gensidig längtan",
      Nobility: "Adel",
      "Noble hostility": "Nobel fientlighet",
      "Non- learning": "Icke-lärande",
      "Non-killing": "Icke-dödande",
      "Non-violence": "Icke-våld",
      "Not drinking liquor": "Inte dricka sprit",
      "Offend not the great": "Kränka inte de stora",
      "Pangs of separation": "Smärtan av separation",
      Penance: "Botgöring",
      "Petty conceit": "Liten självbelåtenhet",
      "Pining alone": "Längtan ensam",
      Poverty: "Fattigdom",
      "Power of speech": "Talens makt",
      "Powerful acts": "Kraftfulla handlingar",
      "Promoting family welfare": "Främja familjens välfärd",
      "Public clamour": "Allmän buller",
      "Purity of action": "Handlingens renhet",
      Renown: "Rykte",
      Renunciation: "Avståndstagande",
      "Reserve lost": "Förlorad reserv",
      "Restraining anger": "Hämma ilska",
      "Sad memories": "Sorgliga minnen",
      "Secret foe": "Dold fiende",
      "Self-control": "Självkontroll",
      "Sensitiveness to shame": "Känslighet för skam",
      "Signs speak the heart": "Tecken talar hjärtat",
      Soliloquy: "Soliloquy",
      Sublimity: "Sublimitet",
      "Sulking charm": "Sulking charm",
      "Sweet words": "Söta ord",
      "Testing and entrusting": "Testning och anförtroende",
      "Testing friendship": "Testa vänskap",
      "Testing of men for confidence": "Testning av män för förtroende",
      "The absence of fraud": "Avsaknaden av bedrägeri",
      "The blessing of Rain": "Regnets välsignelse",
      "The country": "Landet",
      "The cruel tyranny": "Den grymma tyrannin",
      "The embassy": "Ambassaden",
      "The glory of army": "Arméns ära",
      "The grandeur of monarchy": "Monarkins storhet",
      "The merit of Ascetics": "Asketernas förtjänst",
      "The possession of knowledge": "Kunskapens besittning",
      "The power of virtue": "Dygdens makt",
      "The praise of God": "Guds lov",
      "The wealth of children": "Barnens rikedom",
      "The worth of a wife": "En hustrus värde",
      "Truth consciousness": "Sanningens medvetande",
      Unforgetfulness: "Oförglömlighet",
      Veracity: "Sanningsenlighet",
      "Wailing of pining love": "Klagan av längtande kärlek",
      "Wailing over pallor": "Klagan över blekhet",
      "Walk with kings": "Gå med kungar",
      "Wanton women": "Vilda kvinnor",
      "Wasteful look for wistful love": "Slösaktig blick för längtande kärlek",
      "Way of making wealth": "Vägen till att skapa rikedom",
    },
  };

  return translations[targetLanguage]?.[adhigaram] ?? adhigaram;
}
